import { FaAudioDescription, FaVideo, FaSearch, FaBell, FaDownload, FaClock, FaUserShield, FaLock, FaUsers, FaUniversalAccess, FaPlayCircle, FaPlay, FaSave, FaRedo, FaChartLine, FaEdit, FaCheck, FaCheckCircle, FaChessKing, FaSortAmountUp, FaSortAmountDown, FaStop, FaChevronRight, FaChevronLeft, FaArrowLeft, FaOpenid, FaPercentage, } from 'react-icons/fa';
import React, { useState, useEffect } from 'react';
import Header from '../../dashboard/header';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Table, Modal, Button, Form, Dropdown, Alert } from 'react-bootstrap';
import useAuth from '../../dashboard/useAuth';
import { BsPeople } from 'react-icons/bs';
import 'react-quill/dist/quill.snow.css'; // Quill styles
import moment from 'moment';
import axios from 'axios';
import { getAuthToken } from '../../../authToken';

const ConfigurerGroupe = ({ titre }) => {
    useAuth();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });

    const user_id = localStorage.getItem('user_id');
    const { groupe_id } = location.state || {};

    const [donnees_utilisateur, setDonnees_utilisateur] = useState([]);
    const [activeSection, setActiveSection] = useState('infos'); // Nouveau state pour gérer les sections
    const [groupeData, setGroupeData] = useState({});
    const [groupeUsers, setGroupeUsers] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [selectedGroupeUsers, setSelectedGroupeUsers] = useState([]);
    const [selectedAllUsers, setSelectedAllUsers] = useState([]);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [searchGroupe, setSearchGroupe] = useState('');
    const [searchAll, setSearchAll] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [groupeAcces, setGroupeAcces] = useState(null);
    const [selectUtilisateurs, setSelectUtilisateurs] = useState([]);
    const [delaiSelectionne, setDelaiSelectionne] = useState("24");
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingGlobale, setIsLoadingGlobale] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    // rechercher sur les etapes parcours et les utilisateurs du parcours
    const [searchEtape, setSearchEtape] = useState('');
    const [searchUtilisateur, setSearchUtilisateur] = useState('');


    const [listeEtape, setListeEtape] = useState([]);
    const [listeDetailEtapeUtilisateurs, setListeDetailEtapeUtilisateurs] = useState([]);

    const [userData, setUserData] = useState([]);


    const [searchCoach, setSearchCoach] = useState(""); // Recherche dans les coachs disponibles
    const [selectedAvailableCoaches, setSelectedAvailableCoaches] = useState([]); // Coachs sélectionnés (disponibles)

    const [searchGroupCoach, setSearchGroupCoach] = useState(""); // Recherche dans les coachs assignés
    const [selectedGroupCoaches, setSelectedGroupCoaches] = useState([]); // Coachs sélectionnés (assignés)
    const [groupCoaches, setGroupCoaches] = useState([]); // Coachs assignés au groupe
    const [filteredAvailableCoaches, setFilteredAvailableCoaches] = useState([]); // Coachs disponibles
    const [parcoursModal, setParcoursModal] = useState(false);

    // Filtrer les Coachs en fonction de la recherche
    const filteredGroupeCoach = groupCoaches.filter(coach =>
        `${coach.nom} ${coach.prenoms}`.toLowerCase().includes(searchGroupCoach.toLowerCase())
    );

    const filteredAllCoachs = filteredAvailableCoaches.filter(coach =>
        `${coach.nom} ${coach.prenoms}`.toLowerCase().includes(searchCoach.toLowerCase())
    );


    const handleOuvrirParcoursModal = () => setParcoursModal(true);
    const handleFermerParcoursModal = () => setParcoursModal(false);


    const handleAssignerCoach = async () => {
        try {

            const response = await fetch(`${process.env.REACT_APP_HOTE}/assigner-coach/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    {
                        coachs: selectedAvailableCoaches,
                        groupe_id: groupe_id,
                        user_id: user_id,
                    }
                ),
            });
            const result = await response.json();

            if (response.ok) {
                showAlert('Les coachs ont été assignés avec succès.');
                fetchGroupeData();
                fetchCoaches();
            } else {
                showAlert(result.error || 'Erreur lors de l\'assignation des coachs.');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert('Une erreur est survenue.');
        }
    };

    const handleDesassignerCoach = async () => {
        try {

            const response = await fetch(`${process.env.REACT_APP_HOTE}/desassigner-coach/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    {
                        coachs: selectedGroupCoaches,
                        groupe_id: groupe_id,
                        user_id: user_id,
                    }
                ),
            });
            const result = await response.json();

            if (response.ok) {
                showAlert('Les coachs ont été desassignés avec succès.');
                fetchGroupeData();
                fetchCoaches();
            } else {
                showAlert(result.error || 'Erreur lors de l\'assignation des coachs.');
            }
        } catch (error) {
            showAlert('Une erreur est survenue.', error);
        }
    };

    const dropdownStyles = {
        height: '320px',
        padding: '10px',
        borderRadius: '8px',
        border: '1px solid #ccc',
        backgroundColor: '#f9f9f9',
        color: '#333',
        fontSize: '16px',
        marginBottom: '20px',
    };

    const fetchCoaches = async (groupeId) => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/recuperer-coachs-groupe/${groupe_id}/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ groupe_id: groupeId }),
            });

            if (response.ok) {
                const data = await response.json();
                setGroupCoaches(data.coachs_dans_groupe);
                setFilteredAvailableCoaches(data.coachs_hors_groupe);
            } else {
                console.error("Erreur lors de la récupération des coachs :", await response.text());
            }
        } catch (error) {
            console.error("Erreur réseau :", error);
        }
    };
    useEffect(() => {
        if (groupe_id) {
            fetchCoaches();
        }
    }, [groupe_id]);


    useEffect(() => {
        setIsLoadingGlobale(true)
        setLoading(true)
        const fetchUserData = async () => {
            try {

                const token = localStorage.getItem('access_token');

                const response = await fetch(`${process.env.REACT_APP_HOTE}/recup-info-profil/${user_id}/`, {
                    method: 'get',
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
                if (!response.ok) throw new Error('Erreur réseau');
                const data = await response.json();
                setUserData(data);
                setIsLoadingGlobale(false)
                setLoading(false)
            } catch (error) {
                console.error('Erreur lors de la récupération des données utilisateur:', error);
                setIsLoadingGlobale(false)
                setLoading(false)
            }
        };

        fetchUserData();
    }, [user_id]);


    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };


    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline'],
            ['link', 'image'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['clean'],
            [{ 'align': [] }],
        ],
    };

    const navigate = useNavigate();

    const showAlert = (message, type = 'success') => {
        fetchEtapeData()
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 10000);
    };


    const fetchGroupeData = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/groupe-info/${groupe_id}/`);
            if (response.ok) {
                const data = await response.json();
                setGroupeData(data);
            } else {
                const data = await response.json();
                console.error('Erreur lors de la récupération des données du groupe', data);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    useEffect(() => {

        fetchGroupeData();
    }, [groupe_id]);


    const fetchUsers = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/afficher-utilisateurs-du-groupe/${groupe_id}/`);
            if (response.ok) {
                const data = await response.json();
                setGroupeUsers(data.utilisateurs_du_groupe);
                // console.log(groupeUsers)
                setAllUsers(data.tous_utilisateurs);
            } else {
                console.error('Erreur lors de la récupération des utilisateurs');
            }
        } catch (error) {
            console.error('Erreur:', error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, [groupe_id]);

    const ajouterTous = () => {
        setGroupeUsers([...groupeUsers, ...allUsers]);
        setAllUsers([]);
    };

    const ajouterSelection = () => {
        const selectedUsers = allUsers.filter(user => selectedAllUsers.includes(user.id));
        setGroupeUsers([...groupeUsers, ...selectedUsers]);
        setAllUsers(allUsers.filter(user => !selectedAllUsers.includes(user.id)));
        setSelectedAllUsers([]);
    };

    const retirerSelection = () => {
        const selectedUsers = groupeUsers.filter(user => selectedGroupeUsers.includes(user.id));
        setAllUsers([...allUsers, ...selectedUsers]);
        setGroupeUsers(groupeUsers.filter(user => !selectedGroupeUsers.includes(user.id)));
        setSelectedGroupeUsers([]);
    };

    const retirerTous = () => {
        setAllUsers([...allUsers, ...groupeUsers]);
        setGroupeUsers([]);
    };


    const [isLoadingMembre, setIsLoadingMembre] = useState(false);

    const handleSubmit = async () => {
        try {
            setIsLoadingMembre(true)
            const response = await fetch(process.env.REACT_APP_HOTE + `/enregistrer-utilisateurs-groupe/${groupe_id}/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    utilisateurs_ids: groupeUsers.map(user => user.id)
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Erreur:', errorData);
                fetchGroupeData();
                showAlert(errorData);

            } else {
                const responseData = await response.json();
                showAlert('Configuration faite avec succès.');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert('Erreur lors de l\'enregistrement des utilisateurs.');
        } finally {
            setIsLoadingMembre(false)
        }
    };

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Configurer Groupe";
        }
    }, [user_id]);

    const filteredGroupeUsers = groupeUsers.filter(user =>
        `${user.nom} ${user.prenoms}`.toLowerCase().includes(searchGroupe.toLowerCase()) ||
        user.email.toLowerCase().includes(searchGroupe.toLowerCase())
    );

    const filteredAllUsers = allUsers.filter(user =>
        `${user.nom} ${user.prenoms}`.toLowerCase().includes(searchAll.toLowerCase()) ||
        user.email.toLowerCase().includes(searchAll.toLowerCase())
    );

    const handleDefineAccess = () => {
        if (groupe_id) {
            fetchGroupeAcces(groupe_id);
            setShowModal(true);
        }
    };

    const handleCloseModal = () => setShowModal(false);

    const [specialites, setSpecialites] = useState([]);

    useEffect(() => {
        const fetchSpecialites = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const response = await fetch(
                    `${process.env.REACT_APP_HOTE}/liste-specialite/?per_page=100`,
                    {
                        headers: { 'Authorization': `Bearer ${token}` }
                    }
                );
                if (response.ok) {
                    const data = await response.json();
                    setSpecialites(data.liste_spe || []);
                }
            } catch (error) {
                console.error('Erreur chargement spécialités:', error);
            }
        };
        fetchSpecialites();
    }, []);

    const [recherche, setRecherche] = useState(""); // État pour le terme de recherche

    // Fonction pour gérer le changement dans le champ de recherche
    const handleRechercherChange = (e) => {
        setRecherche(e.target.value);
    };

    // Filtrer les utilisateurs en fonction de la recherche
    const filtreUtilisateurs = groupeUsers.filter((user) =>
        `${user.nom} ${user.prenoms}`.toLowerCase().includes(recherche.toLowerCase())
    );

    useEffect(() => {
        const initialSelected = groupeUsers
            .filter((user) => user.qcm === 'oui') // Inclure seulement les utilisateurs avec qcm="oui"
            .map((user) => user.id);
        setSelectUtilisateurs(initialSelected);
    }, [groupeUsers]);



    // Gère la sélection individuelle
    const handleCheckboxChange = (userId) => {
        setSelectUtilisateurs((prevSelected) => {
            // Si l'utilisateur est déjà sélectionné, on le retire, sinon on l'ajoute
            if (prevSelected.includes(userId)) {
                return prevSelected.filter(id => id !== userId);
            } else {
                return [...prevSelected, userId];
            }
        });
    };

    const handleDelaiChange = (e) => {
        const newDelai = e.target.value;
        setDelaiSelectionne(newDelai);
    };


    // Gère la sélection/désélection de tous les utilisateurs
    const handleSelectTous = () => {
        if (selectUtilisateurs.length === groupeUsers.length) {
            setSelectUtilisateurs([]); // Tout désélectionner
        } else {
            setSelectUtilisateurs(groupeUsers.map((user) => user.id)); // Tout sélectionner
        }
    };

    const handleEnregistrer = async () => {
        try {
            // Construire la liste des utilisateurs avec leurs valeurs "oui" ou "non"
            const utilisateursStatuts = groupeUsers.map((user) => ({
                id: user.id,
                statutqcm: selectUtilisateurs.includes(user.id) ? 'oui' : 'non',
            }));

            const countOui = utilisateursStatuts.filter(user => user.statutqcm === 'oui').length;

            const response = await fetch(process.env.REACT_APP_HOTE + `/enregistrer-statut-qcm-utilisateur/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    groupeId: groupe_id,
                    utilisateurs: utilisateursStatuts,
                    // delai: delaiSelectionne,
                }),
            });

            if (response.ok) {
                const data = await response.json();
                showAlert("Configuration enregistrée avec succès");
                fetchGroupeData()
                fetchUsers()
            } else {
                const errorData = await response.json();
                console.error('Erreur:', errorData.error);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };




    useEffect(() => {
        if (groupeUsers.length > 0) {

            // Sélectionner les utilisateurs avec qcm_journalier = 'oui'
            const utilisateursSelectionnes = groupeUsers
                .filter(user => user.qcm_journalier === 'oui')
                .map(user => user.id);


            // Mettre à jour l'état selectUtilisateurs
            setSelectUtilisateurs(utilisateursSelectionnes);
        }
    }, [groupeUsers]);


    const [showResetConfirmation, setShowResetConfirmation] = useState(false);
    const handleReinitialiser = async () => {
        setShowResetConfirmation(false); // Fermer le modal
        try {
            setIsLoading(true); // Activer l'indicateur de chargement

            const response = await fetch(process.env.REACT_APP_HOTE + `/reinitialiser-statut-groupe-et-utilisateurs/${groupe_id}/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.ok) {
                const data = await response.json();
                showAlert("Le groupe a été réinitialisé avec succès !");
                fetchGroupeData()
                fetchUsers()
            } else {
                const error = await response.json();
                console.error("Erreur lors de la réinitialisation :", error.message);
                showAlert("Échec de la réinitialisation : " + error.message);
            }
        } catch (error) {
            console.error("Erreur réseau :", error);
            showAlert("Une erreur est survenue lors de la réinitialisation.");
        } finally {
            setIsLoading(false); // Désactiver l'indicateur de chargement
        }
    }


    const [originalGroupeData, setOriginalGroupeData] = useState({});

    const handleModifier = async (event) => {
        event.preventDefault();
        const formData = {
            nom: groupeData.nom,
            description: groupeData.description,
            type_groupe: groupeData.type_groupe,
            ref_formation: groupeData.ref_formation,
            nbre_apprenant: groupeData.nbre_apprenant,
            specialite_id: groupeData.specialite_id,
        };

        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-groupe/${groupe_id}/${user_id}/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Erreur:', errorData);
            } else {
                const data = await response.json();
                showAlert('Modification éffectuée avec succès');
                fetchGroupeData();
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };



    const handleDemarrerQcm = async () => {
        if (groupe_id) {
            // if (!groupeData?.delai) {
            //     showAlert('Veuillez sélectionner le délai.', 'danger')
            //     return;
            // }
            setIsLoading(true);
            try {

                const response = await fetch(
                    process.env.REACT_APP_HOTE + `/enregistrer-qcm-journalier/${groupe_id}/${user_id}/`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            delai: groupeData.delai,
                        }),
                    }
                );
                const data = await response.json();

                if (response.ok) {
                    showAlert(`Lancement des QCMs journaliers !`);
                    fetchGroupeData()
                    fetchUsers()
                } else {
                    fetchGroupeData()
                    showAlert(data.message)
                    console.error('Erreur lors de la tentative de démarrage des QCMs.', data);
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setIsLoading(false); // Désactive le loader après traitement
            }
        }
    };


    const handlePauseQcm = async () => {
        if (groupe_id) {
            setIsLoading(true); // Affiche le loader sur le bouton
            try {

                const response = await fetch(
                    process.env.REACT_APP_HOTE + `/mettre-pause-qcm-journalier/${groupe_id}/${user_id}/`,
                    {
                        method: 'OPTIONS',
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    }
                );

                if (response.ok) {
                    showAlert(`QCMs journaliers mis en pause !`);
                    fetchGroupeData()
                    fetchUsers()
                } else {
                    const data = await response.json();
                    console.error('Erreur lors de la tentative de mise en pause des QCMs.', data);
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setIsLoading(false); // Désactive le loader après traitement
            }
        }
    };


    const [parcours, setParcours] = useState([]);

    const fetchParcours = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-parcours-dispo/');
            if (response.ok) {
                const data = await response.json();

                // Liste des IDs à exclure
                const parcoursIdsToExclude = Object.values(listeEtape).map(item => item.parcour_id);

                // Filtrer les parcours pour exclure ceux dont l'ID est dans parcoursIdsToExclude
                const filteredData = data.filter(parcoursItem => !parcoursIdsToExclude.includes(parcoursItem.id));

                setParcours(filteredData);
            } else {
                console.error('Erreur lors de la récupération des parcours');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    useEffect(() => {
        if (Object.keys(listeEtape).length > 0 || Object.keys(listeEtape).length === 0) {
            fetchParcours();
        }
    }, [listeEtape]);




    const [loadingParcours, setLoadingParcours] = useState({}); // { parcoursId: boolean }

    const demarrerParcours = async (id) => {
        try {
            setLoadingParcours(prev => ({ ...prev, [id]: true }));

            const response = await fetch(`${process.env.REACT_APP_HOTE}/demarrer-parcours/${id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    groupe_id: groupe_id,
                    user_id: user_id,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                showAlert('Démarrage du parcours.');
                fetchGroupeData()
                fetchEtapeData()
                handleFermerParcoursModal()
                fetchParcours()
                setParcoursSelectionne(null)
            } else {
                showAlert(data.error || 'Erreur lors du lancement.', 'danger');
                handleFermerParcoursModal()
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert('Une erreur s\'est produite.');
        } finally {
            setLoadingParcours(prev => ({ ...prev, [id]: false }));
        }
    };


    const [parcoursSelectionne, setParcoursSelectionne] = useState(null);

    const handleParcoursClick = (parcours) => {
        setParcoursSelectionne(parcours);
    };

    const [modificationMode, setModificationMode] = useState(false); // État pour basculer entre la liste et le formulaire

    const handleModifierClick = () => {
        setModificationMode(true);
    };

    const handleFermerModifier = () => {
        setModificationMode(false);
    };


    const [listeCoach, setListeCoach] = useState([]);

    const fetchListeCoach = async () => {
        try {

            const token = localStorage.getItem('access_token');

            // Envoi au backend
            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-utilisateurs/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            if (response.ok) {
                const data = await response.json();
                setListeCoach(data);
            } else {
                console.error('Erreur lors de la récupération des coach');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };
    useEffect(() => {
        fetchListeCoach();
    }, []);


    const [acces, setAcces] = useState({
        Utilisateurs: false,
        Inscription: false,
        Administration: false,
        Produits: false,
        Groupes: false,
        eligibilite: false,
        AdminEligibilite: false,
        Formation: false,
        Simulation: false,
        QCM: false,
        ExamenBlanc: false,
        AdminExamenBlanc: false,
        Maintenance: false,
        ListeDeDiffusion: false,
        Notification: false,
        Parcours: false,
        Parcoursuser: false,
        Quiz: false,
        AdminQuiz: false,
        EtudeDeCas: false,
        AdminEtudeDeCas: false,
        Apprentisage: false,
        Dashboard: false,
        UtilisateurPartenaire: false,
        Partenaire: false,
        Souscription: false,
        Journalisation: false,
        Rdv: false,
        AdminRdv: false,
        CoachRdv: false,
    });

    // Initialiser les accès en fonction de groupeAcces
    useEffect(() => {
        if (groupeAcces && Array.isArray(groupeAcces) && groupeAcces.length > 0) {
            // Récupérer la chaîne acces du premier élément
            const accesString = groupeAcces[0].acces;

            try {
                // Corriger les apostrophes et parser en tableau
                const accesArray = JSON.parse(accesString.replace(/'/g, '"'));

                const newAcces = {
                    Utilisateurs: accesArray.includes('Utilisateurs'),
                    Inscription: accesArray.includes('Inscription'),
                    Administration: accesArray.includes('Administration'),
                    Produits: accesArray.includes('Produits'),
                    Groupes: accesArray.includes('Groupes'),
                    eligibilite: accesArray.includes('eligibilite'),
                    AdminEligibilite: accesArray.includes('AdminEligibilite'),
                    Formation: accesArray.includes('Formation'),
                    Simulation: accesArray.includes('Simulation'),
                    QCM: accesArray.includes('QCM'),
                    ExamenBlanc: accesArray.includes('ExamenBlanc'),
                    AdminExamenBlanc: accesArray.includes('AdminExamenBlanc'),
                    Maintenance: accesArray.includes('Maintenance'),
                    ListeDeDiffusion: accesArray.includes('ListeDeDiffusion'),
                    Notification: accesArray.includes('Notification'),
                    Parcours: accesArray.includes('Parcours'),
                    Parcoursuser: accesArray.includes('Parcoursuser'),
                    Quiz: accesArray.includes('Quiz'),
                    AdminQuiz: accesArray.includes('AdminQuiz'),
                    EtudeDeCas: accesArray.includes('EtudeDeCas'),
                    AdminEtudeDeCas: accesArray.includes('AdminEtudeDeCas'),
                    Apprentisage: accesArray.includes('Apprentisage'),
                    Dashboard: accesArray.includes('Dashboard'),
                    UtilisateurPartenaire: accesArray.includes('UtilisateurPartenaire'),
                    Partenaire: accesArray.includes('Partenaire'),
                    Souscription: accesArray.includes('Souscription'),
                    Journalisation: accesArray.includes('Journalisation'),
                    AdminRdv: accesArray.includes('AdminRdv'),
                    CoachRdv: accesArray.includes('CoachRdv'),
                    Rdv: accesArray.includes('Rdv'),
                };

                setAcces(newAcces);
            } catch (error) {
                console.error("Erreur lors du parsing de l'accès :", error);
            }
        } else {
            // console.log("Format de groupeAcces invalide ou accès non défini.");
            // console.log('aceessssss',groupeAcces)

            const newAcces = {
                Utilisateurs: false,
                Inscription: false,
                Administration: false,
                Produits: false,
                Groupes: false,
                eligibilite: false,
                AdminEligibilite: false,
                Formation: false,
                Simulation: false,
                QCM: false,
                ExamenBlanc: false,
                AdminExamenBlanc: false,
                Maintenance: false,
                ListeDeDiffusion: false,
                Notification: false,
                Parcours: false,
                Parcoursuser: false,
                Quiz: false,
                AdminQuiz: false,
                EtudeDeCas: false,
                AdminEtudeDeCas: false,
                Apprentisage: false,
                Dashboard: false,
                UtilisateurPartenaire: false,
                Partenaire: false,
                Souscription: false,
                Journalisation: false,
                Rdv: false,
                AdminRdv: false,
                CoachRdv: false,
            };

            setAcces(newAcces);
        }
    }, [groupeAcces]);


    const handleCheckboxAccesChange = (e) => {
        const { name, checked } = e.target;
        setAcces((prevAcces) => ({
            ...prevAcces,
            [name]: checked,
        }));
    };

    const generateAccesArray = () => {
        return Object.keys(acces).filter(key => acces[key]); // Retourner le tableau des accès
    };


    const [isLoadingAcces, setIsLoadingAcces] = useState(false);

    const handleSave = () => {
        const accesArray = generateAccesArray();
        handleAccesChange(accesArray); // Envoyer le tableau au parent
        // handleClose(); // Fermer le modal après l'enregistrement
    };

    const handleAccesChange = async (accesString) => {
        try {
            setIsLoadingAcces(true)
            const response = await fetch(process.env.REACT_APP_HOTE + `/enregistrer-acces-groupe/${groupe_id}/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ acces: accesString }),
            });

            if (response.ok) {
                const responseData = await response.json();

                showAlert('Accès enregistrés avec succès !');
            } else {
                const errorData = await response.json();
                console.error('Erreur lors de l\'enregistrement des accès:', errorData);
            }

        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoadingAcces(false)
        }
    };

    const fetchGroupeAcces = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/groupe-acces/${groupe_id}/`);
            if (response.ok) {
                const data = await response.json();
                setGroupeAcces(data.acces);
                // console.log('aceessssss22222222',data.acces)
            } else {
                console.error('Erreur lors de la récupération des accès du groupe');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };


    useEffect(() => {
        if (user_id) {
            fetchGroupeAcces();
        }
    }, []);

    const reinitialisation = async (parcours_id) => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/reinitialiser-parcours-groupe-utilisateurs/${groupe_id}/${parcours_id}/`);
            if (response.ok) {
                const data = await response.json();
                showAlert('Réinitialisation faite avc succès !')
                fetchGroupeData()
                fetchEtapeData()
                // window.location.reload();
            } else {
                console.error('Erreur lors de la reinitialisation des accès du groupe');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };


    const fetchEtapeData = async () => {
        try {
            // console.log(groupeData.parcours);
            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-etape-groupe/${groupe_id}/`);
            if (response.ok) {
                const data = await response.json();
                setListeEtape(data);
                fetchGroupeData();
            } else {
                const data = await response.json();
                console.error('Erreur lors de la récupération des données du parcours. Code:', data);
                fetchGroupeData();
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const [loadingModalRang, setLoadingModalRang] = useState(false);

    const fetchDetailEtapeUtilisateursData = async (etape_id, parcour_id) => {
        try {
            // console.log(groupeData.parcours);
            setLoadingModalRang(true)
            const response = await fetch(`${process.env.REACT_APP_HOTE}/chercher-details-etape-utilisateurs/${groupe_id}/${parcour_id}/${etape_id}/`);
            if (response.ok) {
                const data = await response.json();
                console.log(data.resultats)
                setListeDetailEtapeUtilisateurs(data.resultats);
                fetchGroupeData();
            } else {
                const data = await response.json();
                console.error('Erreur lors de la récupération des données. Code:', data);
                fetchGroupeData();
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setLoadingModalRang(false)
        }
    };

    const [detailsEtapeUtilisateursModal, setDetailsEtapeUtilisateursModal] = useState(false);

    const handleAfficherDetailsEtapeUtilisateursModal = (etape_id, parcour_id) => {
        setDetailsEtapeUtilisateursModal(true);
        // console.log(etape_id)
        fetchDetailEtapeUtilisateursData(etape_id, parcour_id);
    };
    const handleFermerDetailsEtapeUtilisateursModal = () => setDetailsEtapeUtilisateursModal(false);


    const [pageCourante, setPageCourante] = useState(1);
    const nombreItemsParPage = 10;

    // Calculer les éléments à afficher pour la page actuelle
    const indexDernierItem = pageCourante * nombreItemsParPage;
    const indexPremierItem = indexDernierItem - nombreItemsParPage;
    const itemsPageCourante = listeDetailEtapeUtilisateurs.slice(indexPremierItem, indexDernierItem);

    // Gérer le changement de page
    const changerPage = (numeroPage) => setPageCourante(numeroPage);

    // Calculer le nombre total de pages
    const totalPage = Math.ceil(listeDetailEtapeUtilisateurs.length / nombreItemsParPage);

    // Créer des numéros de page
    const numerosDePage = [];
    for (let i = 1; i <= totalPage; i++) {
        numerosDePage.push(i);
    }



    useEffect(() => {
        fetchEtapeData();
        fetchGroupeData();
    }, []);


    const [isLoadingTerminer, setIsLoadingTerminer] = useState(false);
    const terminerEtape = async (etape, parcours_id) => {
        setIsLoadingTerminer(true)
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/terminer-etape/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    groupe_id: groupe_id,
                    parcours_id: parcours_id,
                    etape_id: etape.id,
                    user_id: user_id,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                showAlert('Etape terminée.');
                fetchEtapeData();
            } else {
                showAlert(data.error || 'Erreur lors de la mise à jour.');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert('Une erreur s\'est produite.');
        } finally {
            setIsLoadingTerminer(false)
        }
    };



    const filteredParcours = parcours.filter(parcours =>
        parcours.titre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        parcours.nbre_heure.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Sort Parcourss
    const sortedParcours = [...filteredParcours].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });


    const [currentPageParcours, setCurrentPageParcours] = useState(1);
    const [itemsParPageParcours, setItemsParPageParcours] = useState(10);
    const totalItemsParcours = parcours.length;
    const totalPagesParcours = Math.ceil(parcours.length / itemsParPageParcours);
    const [searchTermParcours, setSearchTermParcours] = useState('');
    const handleItemsParPageChange = (e) => {
        setItemsParPageParcours(Number(e.target.value));
        setCurrentPageParcours(1);
    };


    const indexOfLastFormation = currentPageParcours * itemsParPageParcours;
    const indexOfFirstFormation = indexOfLastFormation - itemsParPageParcours;
    const currentParcours = sortedParcours.slice(indexOfFirstFormation, indexOfLastFormation);
    const totalPages = Math.ceil(sortedParcours.length / itemsParPageParcours);




    const [etapesUtilisateur, setEtapesUtilisateur] = useState([]);
    const [utilisateurNom, setUtilisateurNom] = useState("");
    const [utilisateurId, setUtilisateurId] = useState("");
    const [cleParcours, setCleParcours] = useState("");

    const [progressionParUtilisateur, setProgressionParUtilisateur] = useState(false);
    const handleOuvrirProgressionParUtilisateur = (fichierParcours, nomComplet, utilisateur_id, parcoursKey) => {
        setEtapesUtilisateur(fichierParcours);
        setUtilisateurNom(nomComplet);
        setUtilisateurId(utilisateur_id);
        setCleParcours(parcoursKey);
        setProgressionParUtilisateur(true);
    };
    const handleFermerProgressionParUtilisateur = () => {
        setProgressionParUtilisateur(false);
        setAfficherDetail(false);
        setEtapesUtilisateur([]);
        setEvaluation(null);
        setEtapeSelectionne('');
    };

    const [afficherDetail, setAfficherDetail] = useState(false);
    const [etapeSelectionne, setEtapeSelectionne] = useState(null);
    const handleVoirClick = (etape) => {
        setEtapeSelectionne(etape);
        setAfficherDetail(true);
    };


    const [evaluation, setEvaluation] = useState([]);

    const [isLoadingEvaluation, setIsLoadingEvaluation] = useState(true);

    useEffect(() => {
        const fetchEvaluation = async () => {
            setIsLoadingEvaluation(true); // Commencer le chargement
            try {
                const url = new URL(process.env.REACT_APP_HOTE + `/historique/${utilisateurId}/${etapeSelectionne?.id}/${cleParcours}/${user_id}/`);

                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                const data = await response.json();
                if (response.ok) {
                    // Filtrer les évaluations pour inclure uniquement celles avec des QCM où `reponse` n'est pas vide
                    const filteredEvaluations = (data.qcms || []).map((evaluation) => {
                        return {
                            ...evaluation,
                            qcm: evaluation.qcm.filter((qcm) => qcm.resultat && qcm.resultat.length > 0)
                        };
                    }).filter((evaluation) => evaluation.qcm.length > 0);

                    setEvaluation(filteredEvaluations); // Mettre à jour l'état avec les QCM filtrés
                    console.log('QCM filtrés:', filteredEvaluations);
                } else {
                    console.log(etapeSelectionne);
                    console.log("Erreur lors de la récupération des données de l'évaluation", data);
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setIsLoadingEvaluation(false); // Terminer le chargement
            }
        };

        fetchEvaluation();
    }, [utilisateurId, etapeSelectionne?.id, cleParcours]);


    // Gérer l'état des évaluations ouvertes/fermées
    const [openEvaluations, setOpenEvaluations] = useState({});

    // Fonction pour gérer le clic sur une évaluation
    const toggleEvaluation = (evaluationId) => {
        setOpenEvaluations((prev) => ({
            ...prev,
            [evaluationId]: !prev[evaluationId], // Bascule entre ouvert/fermé
        }));
    };


    const handleRetour = () => {
        setAfficherDetail(false); // Revenir à la liste principale
        setEtapeSelectionne(null);
    };

    const handleRetourSurEveluation = () => {
        setSelectedEvaluation(null); // Réinitialiser l'évaluation sélectionnée
    };

    const [selectedEvaluation, setSelectedEvaluation] = useState(null);

    const selectEvaluation = (evaluationId) => {
        setSelectedEvaluation(evaluationId === selectedEvaluation ? null : evaluationId);
    };



    const [simulations, setSimulations] = useState([]);
    const [simulationModal, setSimulationModal] = useState(false);
    const [isLoadingSimulation, setIsLoadingSimulation] = useState(false);
    const [utilisateur_sim, setUtilisateur_sim] = useState();

    const fetchSimulations = async (utilisateur) => {
        setIsLoadingSimulation(true);
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/liste-simulation/${utilisateur.id}/`);
            if (response.ok) {
                const data = await response.json();
                const sortedData = data.sort((a, b) => {
                    return new Date(b.date) - new Date(a.date);
                });
                setSimulations(sortedData);
                setSimulationModal(true)
                setUtilisateur_sim(utilisateur)
            } else {
                console.error('Erreur lors de la récupération des simulations');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoadingSimulation(false);
        }
    };

    const [selectedSimulation, setSelectedSimulation] = useState(null);
    const [simulationQcm, setSimulationQcm] = useState([]);
    const [simulation_id, setSimulation_id] = useState();
    const [showTable, setShowTable] = useState(true);

    const handleRowClickSimulation = (simulation) => {
        setSelectedSimulation(simulation);
        // setShowTable(false);
    };

    const handleFermerSimModal = () => {
        setSimulationModal(false);
        setShowTable(true);
        setSelectedSimulation(null);
        setSimulationQcm([]);
    };


    const fetchSimulationsQcm = async (sim) => {
        try {
            // console.log('selectedsim : ', sim.id)
            // const response0 = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-qcms/${user_id}/${simulation_id.id}/`);
            const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-qcms/${utilisateur_sim?.id}/${sim.id}/`);
            if (response.ok) {
                const data = await response.json();
                setSimulationQcm(data.qcms);
            } else {
                console.error('Erreur lors de la récupération des simulations');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };


    const ouvrirSimulation = (selectedSimulation) => {
        setShowTable(false);
        fetchSimulationsQcm(selectedSimulation)
    };




    useEffect(() => {
        // const controller = new AbortController();

        // const fetchSimulationsQcm = async () => {
        //     if (selectedSimulation?.id && utilisateur_sim?.id) {
        //         try {
        //             const response = await fetch(
        //                 `${process.env.REACT_APP_HOTE}/recuperer-simulation/${utilisateur_sim?.id}/${selectedSimulation.id}/`,
        //                 { signal: controller.signal }
        //             );
        //             if (response.ok) {
        //                 const data = await response.json();
        //                 setSimulationQcm(data);
        //             } else {
        //                 console.error('Erreur lors de la récupération des simulations');
        //             }
        //         } catch (error) {
        //             if (error.name !== 'AbortError') {
        //                 console.error('Erreur:', error);
        //             }
        //         }
        //     }else{
        //         console.log('selectedSimulation existe pas')
        //     }
        // };

        fetchSimulationsQcm();

        // return () => controller.abort();
    }, [selectedSimulation?.id, utilisateur_sim?.id]);


    const [preTestProgress, setPreTestProgress] = useState(null);
    const [postTestProgress, setPostTestProgress] = useState(null);
    const [testProgress, setTestProgress] = useState(null);

    const calculateTestProgress = () => {
        if (!listeEtape || Object.keys(listeEtape).length === 0) {
            return { preTest: null, postTest: null };
        }

        // 1. Convertir l'objet en tableau pour mieux manipuler
        const parcoursArray = Object.values(listeEtape);

        if (parcoursArray.length === 0) {
            return { preTest: null, postTest: null };
        }

        // 2. Trier les parcours par ID (ou par date de création) pour obtenir le dernier
        const parcoursTries = parcoursArray.sort((a, b) => {
            // Trier par parcour_id en ordre décroissant pour avoir le dernier en premier
            return b.parcour_id - a.parcour_id;
        });

        const dernierParcoursData = parcoursTries[0];

        console.log("Dernier parcours ID:", dernierParcoursData.parcour_id);
        console.log("Dernier parcours titre:", dernierParcoursData.parcours_titre);

        // 3. Trouver TOUTES les étapes d'évaluation du dernier parcours
        const toutesEtapes = dernierParcoursData.etapes || [];

        // Filtrer par module "Evaluation" ET vérifier le type_evaluation
        const preTestEtapes = toutesEtapes.filter(etape =>
            etape.module && etape.module.toLowerCase().includes("evaluation") &&
            etape.type_evaluation && etape.type_evaluation.toLowerCase() === "pre"
        );

        const postTestEtapes = toutesEtapes.filter(etape =>
            etape.module && etape.module.toLowerCase().includes("evaluation") &&
            etape.type_evaluation && etape.type_evaluation.toLowerCase() === "post"
        );

        console.log("Étapes pré-test trouvées:", preTestEtapes.length);
        console.log("Étapes post-test trouvées:", postTestEtapes.length);

        if (preTestEtapes.length === 0 && postTestEtapes.length === 0) {
            console.log("Aucune étape d'évaluation trouvée dans le dernier parcours");
            return { preTest: null, postTest: null };
        }

        // Prendre la première étape pré-test et la dernière étape post-test
        const preTestEtape = preTestEtapes.length > 0 ? preTestEtapes[0] : null;
        const postTestEtape = postTestEtapes.length > 0 ? postTestEtapes[postTestEtapes.length - 1] : null;

        console.log("Pré-test trouvé:", preTestEtape?.titre, "Type:", preTestEtape?.type_evaluation);
        console.log("Post-test trouvé:", postTestEtape?.titre, "Type:", postTestEtape?.type_evaluation);

        // 4. Calculer les scores pour pré-test et post-test du dernier parcours
        let totalPreTestProgress = 0;
        let totalPostTestProgress = 0;
        let totalUsersPreTest = 0;
        let totalUsersPostTest = 0;

        const utilisateursTraites = new Set();

        dernierParcoursData.utilisateurs.forEach(user => {
            // Pour chaque utilisateur, chercher dans tous ses fichiers du dernier parcours
            user.fichiers.forEach(fichier => {
                // PRÉ-TEST - si une étape pré-test existe dans le dernier parcours
                if (preTestEtape) {
                    const etapePreTestUtilisateur = fichier.etapes.find(e =>
                        e.id === preTestEtape.id ||
                        e.titre === preTestEtape.titre ||
                        (e.type_evaluation && e.type_evaluation.toLowerCase() === "pre")
                    );

                    // Calcul du pré-test
                    if (etapePreTestUtilisateur && etapePreTestUtilisateur.score) {
                        const scorePreTest = calculateScoreFromString(etapePreTestUtilisateur.score);
                        if (scorePreTest !== null) {
                            totalPreTestProgress += scorePreTest;
                            totalUsersPreTest++;
                        }
                    }
                }

                // POST-TEST - si une étape post-test existe dans le dernier parcours
                if (postTestEtape) {
                    const etapePostTestUtilisateur = fichier.etapes.find(e =>
                        e.id === postTestEtape.id ||
                        e.titre === postTestEtape.titre ||
                        (e.type_evaluation && e.type_evaluation.toLowerCase() === "post")
                    );

                    // Calcul du post-test
                    if (etapePostTestUtilisateur && etapePostTestUtilisateur.score) {
                        const scorePostTest = calculateScoreFromString(etapePostTestUtilisateur.score);
                        if (scorePostTest !== null) {
                            totalPostTestProgress += scorePostTest;
                            totalUsersPostTest++;
                            utilisateursTraites.add(user.utilisateur_id);

                            console.log(`${user.utilisateur}: Post-test = ${scorePostTest.toFixed(1)}%`);
                        }
                    }
                }
            });
        });

        // 5. Calculer les moyennes
        const moyennePreTest = totalUsersPreTest > 0 ?
            Math.round((totalPreTestProgress / totalUsersPreTest) * 10) / 10 : null;

        const moyennePostTest = totalUsersPostTest > 0 ?
            Math.round((totalPostTestProgress / totalUsersPostTest) * 10) / 10 : null;

        // 6. Calculer la progression entre pré-test et post-test
        let progression = 0;
        let progressionCalculable = false;

        if (moyennePreTest !== null && moyennePostTest !== null) {
            progression = Math.round((moyennePostTest - moyennePreTest) * 10) / 10;
            progressionCalculable = true;
        }

        return {
            preTest: {
                moyenne: moyennePreTest,
                totalUsers: totalUsersPreTest,
                parcours: dernierParcoursData.parcours_titre,
                parcours_id: dernierParcoursData.parcour_id,
                etape: preTestEtape?.titre,
                type: preTestEtape?.type_evaluation,
                objectifAtteint: moyennePreTest !== null && moyennePreTest >= 30,
                existe: preTestEtape !== null
            },
            postTest: {
                moyenne: moyennePostTest,
                totalUsers: totalUsersPostTest,
                parcours: dernierParcoursData.parcours_titre,
                parcours_id: dernierParcoursData.parcour_id,
                etape: postTestEtape?.titre,
                type: postTestEtape?.type_evaluation,
                objectifAtteint: moyennePostTest !== null && moyennePostTest >= 30,
                existe: postTestEtape !== null
            },
            progression: {
                valeur: progression,
                totalUsers: Math.min(totalUsersPreTest, totalUsersPostTest), // Utilisateurs ayant passé les deux tests
                objectifAtteint: progressionCalculable && progression >= 30,
                calculable: progressionCalculable
            },
            dernierParcoursInfo: {
                id: dernierParcoursData.parcour_id,
                titre: dernierParcoursData.parcours_titre,
                nombreEtapes: toutesEtapes.length,
                nombreUtilisateurs: dernierParcoursData.utilisateurs.length
            }
        };
    };

    // Fonction utilitaire pour extraire le pourcentage d'un score
    const calculateScoreFromString = (scoreStr) => {
        if (!scoreStr) return null;

        const str = scoreStr.toString().trim();

        // Vérifier le format "X/Y"
        if (str.includes('/')) {
            const parts = str.split('/');
            if (parts.length === 2) {
                const scoreObtenu = parseFloat(parts[0]);
                const scoreTotal = parseFloat(parts[1]);

                if (!isNaN(scoreObtenu) && !isNaN(scoreTotal) && scoreTotal > 0) {
                    return (scoreObtenu / scoreTotal) * 100;
                }
            }
        }

        // Si c'est déjà un pourcentage (ex: "75%")
        if (str.includes('%')) {
            const pourcentage = parseFloat(str.replace('%', ''));
            if (!isNaN(pourcentage)) {
                return pourcentage;
            }
        }

        // Si c'est un nombre simple
        const nombre = parseFloat(str);
        if (!isNaN(nombre)) {
            return nombre;
        }

        return null;
    };

    // Utilisation avec useEffect
    useEffect(() => {
        if (Object.keys(listeEtape).length > 0) {
            const results = calculateTestProgress();
            setPreTestProgress(results.preTest);
            setPostTestProgress(results.postTest);
            setTestProgress(results);
            console.log("Résultats tests:", results);
        }
    }, [listeEtape]);

    const verifierParcoursExistant = () => {
        return listeEtape && Object.keys(listeEtape).length > 0;
    };

    const getDernierParcours = () => {
        if (!verifierParcoursExistant()) {
            return null;
        }

        const parcoursArray = Object.values(listeEtape);
        const parcoursTries = parcoursArray.sort((a, b) => {
            return b.parcour_id - a.parcour_id;
        });

        return parcoursTries[0];
    };


    const [sessionsCoaching, setSessionsCoaching] = useState({
        moyenne: 0,
        total_utilisateurs: 0,
        total_sessions: 0,
        loading: true,
        erreur: null
    });


    const fetchSessionsCoaching = async () => {
        try {
            setSessionsCoaching(prev => ({ ...prev, loading: true, erreur: null }));

            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/moyenne-sessions-coaching/${groupe_id}/`
            );

            if (response.ok) {
                const data = await response.json();
                setSessionsCoaching({
                    moyenne: data.moyenne_sessions || 0,
                    total_utilisateurs: data.total_utilisateurs || 0,
                    total_sessions: data.total_sessions || 0,
                    loading: false,
                    erreur: null
                });
            } else {
                const errorData = await response.json();
                setSessionsCoaching(prev => ({
                    ...prev,
                    loading: false,
                    erreur: errorData.message || 'Erreur lors de la récupération des données'
                }));
            }
        } catch (error) {
            console.error('Erreur lors du calcul des sessions de coaching:', error);
            setSessionsCoaching(prev => ({
                ...prev,
                loading: false,
                erreur: 'Erreur réseau ou serveur'
            }));
        }
    };

    useEffect(() => {
        if (groupe_id) {
            fetchSessionsCoaching();
        }
    }, [groupe_id]);


    const [formations, setFormations] = useState([]);
    const [loadingFormations, setLoadingFormations] = useState(false);

    useEffect(() => {
        if (user_id) {
            fetchFormations();
        }
    }, [user_id]);

    const fetchFormations = async () => {
        setLoadingFormations(true);
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-formation/');
            if (response.ok) {
                const data = await response.json();
                // Filtrer les formations actives si nécessaire
                const formationsActives = data.filter(f => f.statut === 'actif' || !f.statut);
                setFormations(formationsActives);
            }
        } catch (error) {
            console.error('Erreur lors du chargement des formations:', error);
        } finally {
            setLoadingFormations(false);
        }
    };


    // Fonctions pour la gestion des dates (comme dans FormulaireAvisClient)
    const isValidDate = (dateString) => {
        if (!dateString) return false;
        const date = new Date(dateString);
        return date instanceof Date && !isNaN(date);
    };

    const normalizeDate = (dateString) => {
        if (!dateString) return null;

        if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
            return dateString;
        }

        if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
            const [day, month, year] = dateString.split('/');
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }

        const date = new Date(dateString);
        if (isValidDate(date)) {
            return date.toISOString().split('T')[0];
        }

        return null;
    };

    const isDateList = (periode) => {
        if (!periode) return false;

        if (typeof periode === 'string') {
            try {
                const cleanedPeriode = periode.replace(/'/g, '"');
                const parsed = JSON.parse(cleanedPeriode);
                return Array.isArray(parsed) && parsed.length > 0;
            } catch (error) {
                return false;
            }
        }

        return Array.isArray(periode) && periode.length > 0;
    };

    const formatFormationPeriod = (periode) => {
        if (!periode || periode === '[]' || periode === '""' || periode === "''") {
            return "À la demande";
        }

        if (isDateList(periode)) {
            try {
                let dates;
                if (typeof periode === 'string') {
                    const cleanedPeriode = periode.replace(/'/g, '"');
                    dates = JSON.parse(cleanedPeriode);
                } else {
                    dates = periode;
                }

                const validDates = dates
                    .map(date => normalizeDate(date))
                    .filter(date => date !== null && isValidDate(new Date(date)))
                    .sort();

                if (validDates.length > 0) {
                    // Retourner une chaîne de caractères au lieu de JSX
                    return validDates.map((date, index) => {
                        const dateObj = new Date(date);
                        return dateObj.toLocaleDateString('fr-FR', {
                            day: '2-digit',
                            month: '2-digit',
                            year: '2-digit'
                        });
                    }).join(', ');
                }
            } catch (error) {
                console.warn('Erreur de parsing des dates:', error);
            }
        }

        if (typeof periode === 'string' && periode.trim() !== '') {
            return periode;
        }

        return '-';
    };

    // Fonction pour obtenir le prix de la formation
    const getPrixFormation = (formationItem) => {
        return formationItem.prix_particulier > 0 && formationItem.prix_particulier
            ? formationItem.prix_particulier
            : formationItem.prix;
    };

    // Fonction pour générer le label complet d'une formation
    const getFormationLabel = (formation) => {
        if (!formation) return '';

        const baseLabel = formation.nom;
        const periodLabel = formatFormationPeriod(formation.periode);

        // Prix en fonction du type de financement
        const prix = getPrixFormation(formation);
        const priceLabel = prix ? `${parseInt(prix).toLocaleString('fr-FR')} FCFA HT` : '';

        return `${baseLabel} (${periodLabel}) ${priceLabel ? `- ${priceLabel}` : ''}`;
    };

    // État pour les dates étendues
    const [expandedDates, setExpandedDates] = useState({});

    // Fonction pour afficher toutes les dates (comme dans FormulaireAvisClient)
    const getAllDatesDisplay = (periode, formationId) => {
        // Vérifier si periode est vide, null, ou un tableau vide
        if (!periode || periode === '[]' || periode === '""' || periode === "''") {
            return 'À la demande';
        }

        if (isDateList(periode)) {
            try {
                let dates;
                if (typeof periode === 'string') {
                    // Nettoyer la chaîne - remplacer les guillemets simples par des doubles
                    const cleanedPeriode = periode.replace(/'/g, '"');
                    dates = JSON.parse(cleanedPeriode);
                } else {
                    dates = periode;
                }

                // Vérifier si le tableau est vide après parsing
                if (!Array.isArray(dates) || dates.length === 0) {
                    return 'À la demande';
                }

                const validDates = dates
                    .map(date => normalizeDate(date))
                    .filter(date => date !== null && isValidDate(new Date(date)))
                    .sort();

                if (validDates.length > 0) {
                    const isExpanded = expandedDates[formationId];
                    const displayDates = isExpanded ? validDates : validDates.slice(0, 3);
                    const remainingCount = validDates.length - 3;

                    const toggleDates = (e) => {
                        e.stopPropagation(); // Empêcher la sélection de la ligne
                        setExpandedDates(prev => ({
                            ...prev,
                            [formationId]: !prev[formationId]
                        }));
                    };

                    const textColorClass = 'text-muted';
                    const linkColorClass = 'text-primary';

                    return (
                        <div className="small" style={{
                            wordWrap: 'break-word',
                            whiteSpace: 'normal',
                            lineHeight: '1.4'
                        }}>
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '4px',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                {displayDates.map((date, index) => {
                                    const dateObj = new Date(date);
                                    return (
                                        <span
                                            key={index}
                                            className={textColorClass}
                                            style={{
                                                whiteSpace: 'nowrap',
                                                flexShrink: 0
                                            }}
                                        >
                                            {dateObj.toLocaleDateString('fr-FR', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: '2-digit'
                                            })}
                                            {index < displayDates.length - 1 && ','}
                                        </span>
                                    );
                                })}
                                {!isExpanded && remainingCount > 0 && (
                                    <span
                                        className={`${linkColorClass} ms-1`}
                                        style={{
                                            cursor: 'pointer',
                                            textDecoration: 'underline',
                                            flexShrink: 0,
                                            whiteSpace: 'nowrap'
                                        }}
                                        onClick={toggleDates}
                                        title="Cliquer pour voir toutes les dates"
                                    >
                                        ...(+{remainingCount})
                                    </span>
                                )}
                                {isExpanded && remainingCount > 0 && (
                                    <span
                                        className={`${linkColorClass} ms-1`}
                                        style={{
                                            cursor: 'pointer',
                                            textDecoration: 'underline',
                                            flexShrink: 0,
                                            whiteSpace: 'nowrap'
                                        }}
                                        onClick={toggleDates}
                                        title="Cliquer pour réduire"
                                    >
                                        (réduire)
                                    </span>
                                )}
                            </div>
                        </div>
                    );
                } else {
                    return 'À la demande';
                }
            } catch (error) {
                console.warn('Erreur de parsing des dates:', error);
                return 'À la demande';
            }
        }

        // Si ce n'est pas une liste de dates mais une chaîne non vide
        if (typeof periode === 'string' && periode.trim() !== '' && periode !== '[]') {
            return (
                <span className={`small text-muted`}>
                    {periode}
                </span>
            );
        }

        return 'À la demande';
    };



    const [moyenneAvisClient, setMoyenneAvisClient] = useState(null);
    const [loadingMoyenneAvis, setLoadingMoyenneAvis] = useState(false);

    // 2. Modifiez la fonction fetchMoyenneAvisClient
    const fetchMoyenneAvisClient = async (groupeId) => {
        setLoadingMoyenneAvis(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/moyenne-avis-client-groupe/${groupeId}/`);
            if (response.ok) {
                const data = await response.json();
                console.log('Moyenne avis client:', data);
                setMoyenneAvisClient(data);
                return data;
            } else {
                console.error('Erreur lors de la récupération de la moyenne');
                setMoyenneAvisClient(null);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            setMoyenneAvisClient(null);
        } finally {
            setLoadingMoyenneAvis(false);
        }
    };

    // 3. Dans votre useEffect
    useEffect(() => {
        if (groupe_id) {
            fetchMoyenneAvisClient(groupe_id);
        }
    }, [groupe_id]);


    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);


    if (!accesGroupe.includes("Groupes")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }



    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><BsPeople size={25} className='mr-2' />Configurer Groupe</h2>
                            <small>Administration des groupes d'utilisateurs.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-groupe`}>Groupes</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <span>{groupeData.nom} / Configurer Groupe </span>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>


                    {alert.message && (
                        <div className={`alert mt-3 alert-${alert.type}`} role="alert"
                            dangerouslySetInnerHTML={{ __html: alert.message }} />
                    )}

                    <div className="container-fluid">
                        <div className="mt-3 mb-5">
                            <div className="row wrapper wrapper-content animated fadeInRight">
                                <div className="col-md-3 ibox-content border-end mr-4 ml-4" style={{ borderRadius: "15px" }}>
                                    <div className="btn-group-vertical w-100 text-start">
                                        <button
                                            className={`btn text-start py-2 d-flex align-items-center ${activeSection === 'infos' ? 'bg-light text-dark border border-secondary fw-bold' : 'btn-light'}`}
                                            onClick={() => setActiveSection('infos')}
                                        >
                                            <FaUserShield className="me-2 ml-2 mr-2" />
                                            <span>Infos</span>
                                        </button>
                                        <button
                                            className={`btn text-start mt-2 py-2 d-flex align-items-center ${activeSection === 'acces' ? 'bg-light text-dark border border-secondary fw-bold' : 'btn-light'}`}
                                            onClick={() => setActiveSection('acces')}
                                        >
                                            <FaUniversalAccess className="me-2 ml-2 mr-2" />
                                            <span>Accès</span>
                                        </button>
                                        <button
                                            className={`btn text-start mt-2 py-2 d-flex align-items-center ${activeSection === 'membres' ? 'bg-light text-dark border border-secondary fw-bold' : 'btn-light'}`}
                                            onClick={() => setActiveSection('membres')}
                                        >
                                            <FaUsers className="me-2 ml-2 mr-2" />
                                            <span>Membres ({groupeUsers.length || '0'})</span>
                                        </button>

                                        {loading ? (
                                            ""
                                        ) : !userData?.coach_groupe && (<button
                                            className={`btn text-start mt-2 py-2 d-flex align-items-center ${activeSection === 'coach' ? 'bg-light text-dark border border-secondary fw-bold' : 'btn-light'}`}
                                            onClick={() => setActiveSection('coach')}
                                        >
                                            <FaChessKing className="me-2 ml-2 mr-2" />
                                            <span>Coach ({groupCoaches.length || '0'})</span>
                                        </button>
                                        )}

                                        {/* {(!userData.coach_groupe || userData.coach_groupe === "") && ( // Affiche cette section uniquement si coach_groupe est vide
                                            <button
                                                className={`btn text-start mt-2 py-2 d-flex align-items-center ${activeSection === 'coach' ? 'bg-light text-dark border border-secondary fw-bold' : 'btn-light'}`}
                                                onClick={() => setActiveSection('coach')}
                                            >
                                                <FaChessKing className="me-2 ml-2 mr-2" />
                                                <span>Coach ({groupCoaches.length || '0'})</span>
                                            </button>
                                        )} */}
                                        <button
                                            className={`btn text-start mt-2 py-2 d-flex align-items-center ${activeSection === 'parcours' ? 'bg-light text-dark border border-secondary fw-bold' : 'btn-light'}`}
                                            onClick={() => setActiveSection('parcours')}
                                        >
                                            <FaChartLine className="me-2 ml-2 mr-2" />
                                            <span>Parcours</span>
                                        </button>
                                        <button
                                            className={`btn text-start mt-2 py-2 d-flex align-items-center ${activeSection === 'QCM-30J' ? 'bg-light text-dark border border-secondary fw-bold' : 'btn-light'}`}
                                            onClick={() => setActiveSection('QCM-30J')}
                                        >
                                            <FaPlayCircle className="me-2 ml-2 mr-2" />
                                            <span>QCM-30J {groupeData.qcm_journalier_statut ? `(${groupeData.qcm_journalier_statut})` : ''}</span>
                                        </button>
                                        <button
                                            className={`btn text-start mt-2 py-2 d-flex align-items-center ${activeSection === 'KPI' ? 'bg-light text-dark border border-secondary fw-bold' : 'btn-light'}`}
                                            onClick={() => setActiveSection('KPI')}
                                        >
                                            <FaPercentage className="me-2 ml-2 mr-2" />
                                            <span>KPI</span>
                                        </button>
                                    </div>
                                </div>

                                {!isLoadingGlobale ? (

                                    <div className="col-md-8 ibox-content" style={{ borderRadius: "15px" }}>
                                        {activeSection === 'infos' && (
                                            <div className=''>
                                                <div className="ibox-title">
                                                    <h4>Modifier le groupe</h4>
                                                </div>
                                                <div className="ibox-content">
                                                    <form className="m-t" role="form" encType="multipart/form-data">
                                                        {/* Formulaire pour le nom */}
                                                        <div className="form-group">
                                                            <label>Nom*</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                required
                                                                name="nom"
                                                                value={groupeData.nom || ''}
                                                                onChange={(e) => setGroupeData({ ...groupeData, nom: e.target.value })}
                                                            />
                                                        </div>

                                                        {/* Formulaire pour la description avec Quill */}
                                                        <div className="form-group">
                                                            <label>Description</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                required
                                                                name="description"
                                                                value={groupeData.description || ''}
                                                                onChange={(e) => setGroupeData({ ...groupeData, description: e.target.value })}
                                                            />
                                                        </div>

                                                        <div className='row'>
                                                            {(!userData.coach_groupe || userData.coach_groupe === "") && (
                                                                <div className={`form-group ${groupeData.type_groupe === "Cohorte" ? 'col-md-6' : 'col-md-12'}`}>
                                                                    <label>Type du groupe*</label>
                                                                    <select
                                                                        className="form-control m-b"
                                                                        name="type_groupe"
                                                                        value={groupeData.type_groupe}
                                                                        onChange={(e) => setGroupeData({ ...groupeData, type_groupe: e.target.value })}
                                                                    >
                                                                        <option value="Cohorte">Cohorte</option>
                                                                        <option value="Groupe système">Groupe système</option>
                                                                    </select>
                                                                </div>
                                                            )}

                                                            {groupeData.type_groupe === "Cohorte" && (
                                                                <div className="form-group col-md-6">
                                                                    <label>Nombre d'apprenant prévu*</label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        required
                                                                        name="nbre_apprenant"
                                                                        value={groupeData.nbre_apprenant || ''}
                                                                        onChange={(e) => setGroupeData({ ...groupeData, nbre_apprenant: e.target.value })}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Formation + Spécialité sur la même ligne */}
                                                        {groupeData.type_groupe === "Cohorte" && (
                                                            <div className="row">
                                                                <div className="form-group col-md-6">
                                                                    <label>Formation</label>
                                                                    <select
                                                                        className="form-control m-b"
                                                                        name="ref_formation"
                                                                        value={groupeData.ref_formation || ''}
                                                                        onChange={(e) => setGroupeData({ ...groupeData, ref_formation: e.target.value })}
                                                                        disabled={loadingFormations}
                                                                    >
                                                                        <option value="">Sélectionner une formation</option>
                                                                        {loadingFormations ? (
                                                                            <option>Chargement des formations...</option>
                                                                        ) : (
                                                                            formations.map(formation => (
                                                                                <option key={formation.id || formation.reference} value={formation.reference}>
                                                                                    {getFormationLabel(formation)}
                                                                                </option>
                                                                            ))
                                                                        )}
                                                                    </select>
                                                                </div>

                                                                <div className="form-group col-md-6">
                                                                    <label>Produit*</label>
                                                                    <select
                                                                        className="form-control m-b"
                                                                        name="specialite_id"
                                                                        value={groupeData.specialite_id || ''}
                                                                        onChange={(e) => setGroupeData({ ...groupeData, specialite_id: e.target.value })}
                                                                        required
                                                                    >
                                                                        <option value="">Produit</option>
                                                                        {specialites.map(spec => (
                                                                            <option key={spec.id} value={spec.id}>
                                                                                {spec.titre}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                    <small className="text-muted">
                                                                        Le produit détermine les tags des QCM-30J.
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </form>
                                                </div>
                                                <div className="text-center mt-4">
                                                    <button type="submit" className="btn btn-success" onClick={handleModifier}>
                                                        Enregistrer
                                                    </button>
                                                </div>
                                            </div>
                                        )}

                                        {activeSection === 'QCM-30J' && (
                                            <div className="">
                                                <div className='ibox-title d-flex justify-content-between pr-2'>
                                                    <h4>QCM-30J</h4>
                                                    {/* Badge du groupe */}
                                                    <div className="">
                                                        <span className="badge badge-success">
                                                            {groupeData?.qcm_journalier_jour || ''}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className='ibox-content'>
                                                    <Form>

                                                        {/* Champ de recherche */}
                                                        <Form.Group className="mb-3" controlId="searchUser">
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Rechercher un utilisateur..."
                                                                value={recherche}
                                                                onChange={handleRechercherChange}
                                                            />
                                                        </Form.Group>

                                                        {/* Option pour sélectionner/désélectionner tous les utilisateurs */}
                                                        <Form.Check
                                                            className="mb-3"
                                                            type="checkbox"
                                                            id="select-all"
                                                            label="Sélectionner tous les utilisateurs"
                                                            checked={selectUtilisateurs.length === groupeUsers.length && groupeUsers.length > 0}
                                                            onChange={handleSelectTous}
                                                        />

                                                        {/* Liste des utilisateurs */}
                                                        <div className="table-container">
                                                            <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Sélection</th>
                                                                        <th>Nom</th>
                                                                        <th>Date</th>
                                                                        <th>Statut</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {filtreUtilisateurs.map((user) => (
                                                                        <tr key={user.id}>
                                                                            <td>
                                                                                <Form.Check
                                                                                    type="checkbox"
                                                                                    id={`user-${user.id}`}
                                                                                    label=""
                                                                                    checked={selectUtilisateurs.includes(user.id)} // Vérifie si l'utilisateur est sélectionné
                                                                                    onChange={() => handleCheckboxChange(user.id)} // Change l'état de sélection
                                                                                />
                                                                            </td>
                                                                            <td>{`${user.nom} ${user.prenoms}`}</td>
                                                                            <td>{user?.qcm_journalier_jour_date || ''}</td>
                                                                            <td>
                                                                                <span className="badge badge-success">{user?.qcm_journalier_jour || ''}</span>
                                                                            </td>
                                                                            <td>
                                                                                {isLoadingSimulation ? (
                                                                                    <span className="badge badge-success mr-2" disabled>
                                                                                        <i className="fa fa-spinner fa-spin mr-1"></i>
                                                                                    </span>
                                                                                ) : (
                                                                                    <span className="badge badge-success btn-sm" onClick={() => fetchSimulations(user)} style={{ cursor: "pointer" }}>Détail..</span>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        {/* Boutons d'action */}
                                                        <div className="text-right mt-4">
                                                            <Button variant="success" onClick={handleEnregistrer} className="ml-2">
                                                                <FaSave /> Enregistrer
                                                            </Button>
                                                        </div>
                                                        {/* Choix du délai */}
                                                        <Form.Group className="mb-3" controlId="selectDelai">
                                                            <Form.Label>Délai d'inactivité :</Form.Label>
                                                            <Form.Control
                                                                as="select"
                                                                value={groupeData?.delai || "24"}
                                                                onChange={(e) => {
                                                                    setGroupeData({ ...groupeData, delai: e.target.value });
                                                                    setDelaiSelectionne(e.target.value);
                                                                }}
                                                            >
                                                                <option value="24">24h</option>
                                                                <option value="48">48h</option>
                                                                <option value="72">72h</option>
                                                                <option value="168">1 semaine</option>
                                                            </Form.Control>
                                                        </Form.Group>
                                                        {/* Boutons d'action */}
                                                        <div className="text-right mt-4 mb-4">
                                                            <Button
                                                                variant="warning"
                                                                onClick={() => setShowResetConfirmation(true)}
                                                                disabled={isLoading}
                                                            >
                                                                {isLoading ? (
                                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                ) : (
                                                                    <>
                                                                        <FaRedo /> Réinitialiser
                                                                    </>
                                                                )}
                                                            </Button>

                                                            {groupeData?.qcm_journalier_statut === 'En cours' ? (
                                                                <Button
                                                                    variant="success"
                                                                    onClick={handlePauseQcm}
                                                                    className="ml-2"
                                                                // disabled={isLoading || groupeData?.qcm_journalier_statut === 'En cours' || groupeData?.qcm_journalier_statut === 'Terminé'}
                                                                >
                                                                    {isLoading ? (
                                                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                    ) : (
                                                                        <FaStop />
                                                                    )}
                                                                </Button>
                                                            ) : (
                                                                <Button
                                                                    variant="success"
                                                                    onClick={handleDemarrerQcm}
                                                                    className="ml-2"
                                                                // disabled={isLoading || groupeData?.qcm_journalier_statut === 'En cours' || groupeData?.qcm_journalier_statut === 'Terminé'}
                                                                >
                                                                    {isLoading ? (
                                                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                    ) : (
                                                                        <FaPlay />
                                                                    )}
                                                                </Button>
                                                            )}

                                                            {/* Modal de confirmation pour la réinitialisation */}
                                                            <Modal show={showResetConfirmation} onHide={() => setShowResetConfirmation(false)}>
                                                                <Modal.Header>
                                                                    <Modal.Title>Confirmation de réinitialisation</Modal.Title>
                                                                </Modal.Header>
                                                                <Modal.Body>
                                                                    <p>Êtes-vous sûr de vouloir réinitialiser le QCM-30J pour tous les utilisateurs de ce groupe ?</p>
                                                                    <p className="text-warning"><strong>Attention :</strong> Cette action est irréversible et remettra à zéro tous les progrès des utilisateurs.</p>
                                                                </Modal.Body>
                                                                <Modal.Footer>
                                                                    <Button variant="secondary" onClick={() => setShowResetConfirmation(false)}>
                                                                        Annuler
                                                                    </Button>
                                                                    <Button variant="warning" onClick={handleReinitialiser} disabled={isLoading}>
                                                                        {isLoading ? (
                                                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                        ) : (
                                                                            'Confirmer la réinitialisation'
                                                                        )}
                                                                    </Button>
                                                                </Modal.Footer>
                                                            </Modal>


                                                        </div>

                                                    </Form>
                                                </div>

                                                <Modal show={simulationModal} onHide={handleFermerSimModal} size="lg">
                                                    <Modal.Header>
                                                        <Modal.Title>QCM-30J ({`${utilisateur_sim?.nom} ${utilisateur_sim?.prenoms}`})</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <div>
                                                            <div className="d-flex justify-content-end">
                                                                {showTable ? (
                                                                    <button
                                                                        onClick={() => ouvrirSimulation(selectedSimulation)}
                                                                        className={`btn d-flex align-items-center justify-content-center ms-2 me-2 mt-1 ${selectedSimulation ? 'btn-success' : 'btn-default text-dark'}`}
                                                                        disabled={!selectedSimulation}
                                                                    >
                                                                        <span className="d-none d-sm-inline ms-2">Ouvrir</span>
                                                                    </button>
                                                                ) : (
                                                                    <Button variant="secondary" onClick={() => setShowTable(true)}>Retour</Button>
                                                                )}
                                                            </div>

                                                            {showTable ? (
                                                                <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                                    <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                                        <thead>
                                                                            <tr>
                                                                                <th className="text-secondary d-none d-md-table-cell" onClick={() => handleSort('date')}>
                                                                                    Date {sortConfig.key === 'date' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                                </th>
                                                                                <th className="text-secondary d-none d-md-table-cell" onClick={() => handleSort('qcmNumber')}>
                                                                                    Nbre de questions {sortConfig.key === 'qcmNumber' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                                </th>
                                                                                <th className="text-secondary d-none d-md-table-cell" onClick={() => handleSort('langue')}>
                                                                                    Langue {sortConfig.key === 'langue' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                                </th>
                                                                                <th className="text-secondary d-none d-md-table-cell" onClick={() => handleSort('tags')}>
                                                                                    Tags {sortConfig.key === 'tags' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                                </th>
                                                                                <th className="text-secondary d-none d-md-table-cell" onClick={() => handleSort('reussite')}>
                                                                                    Réussite {sortConfig.key === 'reussite' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {!isLoading ? (
                                                                                simulations.map((simulation) => (
                                                                                    <tr
                                                                                        key={simulation.id}
                                                                                        onClick={() => handleRowClickSimulation(simulation)}
                                                                                        className={`bg-white ${selectedSimulation && selectedSimulation.id === simulation.id ? 'bg-success text-white' : ''}`}
                                                                                    >
                                                                                        <td>
                                                                                            {simulation.date}
                                                                                            <div className='lesInfos'>
                                                                                                <small>Nbre de questions : {simulation.qcmNumber}</small><br />
                                                                                                <small>Langue : {simulation.langue}</small><br />
                                                                                                <small>Tags : {simulation.tags}</small><br />
                                                                                                <small>Pourcentage : {simulation.pourcentage ? simulation.pourcentage + "%" : "0%"}</small>
                                                                                            </div>
                                                                                        </td>
                                                                                        <td className="d-none d-md-table-cell">{simulation.qcmNumber}</td>
                                                                                        <td className="d-none d-md-table-cell">{simulation.langue}</td>
                                                                                        <td className="d-none d-md-table-cell">{simulation.tags}</td>
                                                                                        <td className="d-none d-md-table-cell">{simulation.pourcentage ? simulation.pourcentage + "%" : "0%"}</td>
                                                                                    </tr>
                                                                                ))
                                                                            ) : (
                                                                                <div className="mt-3 d-flex justify-content-center align-items-center" style={{ height: '100%', width: '100%' }}>
                                                                                    <span className="spinner-border spinner-border-lg text-success" role="status" aria-hidden="true" style={{ width: '3rem', height: '3rem' }}></span>
                                                                                </div>
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            ) : (
                                                                <div>
                                                                    <div className="">
                                                                        {simulationQcm.length > 0 ? (
                                                                            simulationQcm.map((qcm) => (
                                                                                <div key={qcm.id} style={{ borderBottom: '1px solid #ccc', paddingBottom: '15px', marginBottom: '15px' }}>
                                                                                    <input type="hidden" name="qcmidhidden" id="qcmidhidden" value={qcm.id} />
                                                                                    <div>
                                                                                        <span># {qcm.ref} - </span>
                                                                                        <span
                                                                                            id="question"
                                                                                            style={{ fontSize: '13px' }}
                                                                                            dangerouslySetInnerHTML={{ __html: qcm.question }}
                                                                                        ></span>
                                                                                    </div>
                                                                                    <div style={{ margin: '10px 10px' }}>
                                                                                        {Object.keys(qcm)
                                                                                            .filter((key) => key.startsWith('option') && qcm[key] && qcm[key] != 'non défini') // On ne prend que les options qui existent
                                                                                            .map((key, optionIndex) => {
                                                                                                const optionLetter = String.fromCharCode(65 + optionIndex); // Générer dynamiquement A, B, C, ...
                                                                                                const optionText = qcm[key]; // Texte de l'option
                                                                                                const isCorrectAnswer = Array.isArray(qcm.reponse) && qcm.reponse.includes(optionLetter); // Vérifie si c'est une bonne réponse
                                                                                                const isUserAnswer = Array.isArray(qcm.resultat) && qcm.resultat.includes(optionLetter); // Vérifie si l'utilisateur a sélectionné cette option

                                                                                                return (
                                                                                                    <div
                                                                                                        key={key}
                                                                                                        style={{
                                                                                                            display: 'flex',
                                                                                                            alignItems: 'center',
                                                                                                            marginBottom: '10px',
                                                                                                            fontSize: '12px',
                                                                                                        }}
                                                                                                    >
                                                                                                        <span style={{ marginRight: '2px' }}>
                                                                                                            {optionLetter} - {optionText}
                                                                                                        </span>

                                                                                                        {/* Gestion des icônes */}
                                                                                                        {isCorrectAnswer && isUserAnswer ? (
                                                                                                            // Réponse correcte sélectionnée
                                                                                                            <i
                                                                                                                className="fa fa-thumbs-o-up fa-2x"
                                                                                                                style={{ color: 'green', marginLeft: '5px' }}
                                                                                                                title="Correct Answer (Selected)"
                                                                                                            ></i>
                                                                                                        ) : isUserAnswer && !isCorrectAnswer ? (
                                                                                                            // Réponse sélectionnée mais incorrecte
                                                                                                            <i
                                                                                                                className="fa fa-thumbs-o-down fa-2x"
                                                                                                                style={{ color: 'red', marginLeft: '5px' }}
                                                                                                                title="Incorrect Answer (Selected)"
                                                                                                            ></i>
                                                                                                        ) : isCorrectAnswer ? (
                                                                                                            // Réponse correcte non sélectionnée
                                                                                                            <i
                                                                                                                className="fa fa-thumbs-o-up fa-2x"
                                                                                                                style={{ color: 'green', marginLeft: '5px' }}
                                                                                                                title="Correct Answer"
                                                                                                            ></i>
                                                                                                        ) : null}
                                                                                                    </div>
                                                                                                );
                                                                                            })}
                                                                                        <div style={{ marginTop: '10px', fontStyle: 'italic', color: 'blue' }}>
                                                                                            <p>
                                                                                                Bonnes réponses : {
                                                                                                    (() => {
                                                                                                        const r = Array.isArray(qcm.reponse)
                                                                                                            ? qcm.reponse.filter(item => item && item.trim && item.trim() !== '' && item.trim() !== 'non défini')
                                                                                                            : typeof qcm.reponse === 'string' && qcm.reponse.includes(',')
                                                                                                                ? qcm.reponse.split(',').map(item => item.trim()).filter(item => item !== '' && item !== 'non défini')
                                                                                                                : qcm.reponse && qcm.reponse !== 'non défini' ? [qcm.reponse] : [];
                                                                                                        return r.length > 0 ? r.join(', ') : 'Non défini';
                                                                                                    })()
                                                                                                }
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>
                                                                                    {qcm.explication && qcm.explication != 'non défini' && (
                                                                                        <div style={{ color: 'green' }}>
                                                                                            <span>Explication : </span>
                                                                                            <span
                                                                                                id="explication"
                                                                                                style={{
                                                                                                    fontSize: '12px',
                                                                                                    color: 'green',
                                                                                                    marginTop: '10px',
                                                                                                }}
                                                                                                dangerouslySetInnerHTML={{ __html: qcm.explication }}
                                                                                            />
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            ))
                                                                        ) : (
                                                                            <p>Aucun QCM avec résultat trouvé pour cette simulation.</p>
                                                                        )}
                                                                    </div>
                                                                </div> // Remplace le tableau par une div vide
                                                            )}
                                                        </div>
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        <Button variant="secondary" onClick={handleFermerSimModal}>Fermer</Button>
                                                    </Modal.Footer>
                                                </Modal>

                                            </div>
                                        )}

                                        {activeSection === 'parcours' && (
                                            <div className="container mt-4 ibox">
                                                <div className='ibox-title d-flex justify-content-between p-3'>
                                                    <h4>Parcours</h4>
                                                    <button className='btn btn-success p-1' onClick={handleOuvrirParcoursModal}>Liste des parcours</button>
                                                </div>
                                                <div className='ibox-content table-container-content'>
                                                    <div>
                                                        {/* Affichage des parcours et étapes */}
                                                        {Object.keys(listeEtape).map((parcoursKey) => {
                                                            const parcoursData = listeEtape[parcoursKey];

                                                            // Calcul du pourcentage des étapes dépassées
                                                            const totalEtapes = parcoursData.etapes.length;
                                                            const etapesDepassees = parcoursData.etapes.filter((etape) => {
                                                                return etape.date_echeance && moment(etape.date_echeance, "DD/MM/YYYY").endOf('day').isBefore(moment());
                                                            }).length;

                                                            const pourcentageEtapesDepassees = totalEtapes > 0 ? Math.round((etapesDepassees / totalEtapes) * 100) : 0;
                                                            return (
                                                                <div key={parcoursKey}>
                                                                    <div className='d-flex justify-content-between'>
                                                                        <h3>
                                                                            {parcoursData.parcours_titre}
                                                                            <span className='badge badge-success ml-2'>{pourcentageEtapesDepassees}%</span>
                                                                        </h3>
                                                                        {/* {accesGroupe.includes("Parcours") &&
                                                                            <div className="text-right mb-3">
                                                                                <button
                                                                                    onClick={() => reinitialisation(parcoursData.parcour_id)}
                                                                                    className="btn align-items-center btn-warning"
                                                                                >
                                                                                    <FaRedo className="mr-2" />
                                                                                    Réinitialiser
                                                                                </button>
                                                                            </div>
                                                                        } */}


                                                                    </div>


                                                                    {/* <div className='d-flex justify-content-between mb-2'>
                                                                        <div className='col-md-6'>
                                                                            <input
                                                                                type="text"
                                                                                placeholder="Rechercher..."
                                                                                className="form-control"
                                                                                style={{ maxWidth: '150px', width: '100%' }} // Largeur fixe ou maximale selon besoin
                                                                                value={searchEtape}
                                                                                onChange={(e) => setSearchEtape(e.target.value)}
                                                                            />
                                                                        </div>
                                                                   
                                                                        <div className='col-md-6'>
                                                                            <input
                                                                                type="text"
                                                                                placeholder="Rechercher..."
                                                                                className="form-control"
                                                                                style={{ maxWidth: '150px', width: '100%' }} // Largeur fixe ou maximale selon besoin
                                                                                value={searchUtilisateur}
                                                                                onChange={(e) => setSearchUtilisateur(e.target.value)}
                                                                            />
                                                                        </div>
                                                                    </div> */}
                                                                    <div className='d-flex justify-content-between mb-3'>
                                                                        {/* Table des étapes pour chaque parcours */}

                                                                        <div className="col-md-6 table-container">
                                                                            <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('titre')}>
                                                                                            Titre
                                                                                            {sortConfig.key === 'titre' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                                        </th>
                                                                                        <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('date_echeance')}>
                                                                                            Échéance
                                                                                            {sortConfig.key === 'date_echeance' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                                        </th>
                                                                                        <th className="text-secondary text-wrap d-none d-md-table-cell">Action</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {/* Affichage des étapes du parcours */}
                                                                                    {parcoursData.etapes.map((etape) => {
                                                                                        const isDateDepassee = etape.date_echeance && moment(etape.date_echeance, "DD/MM/YYYY").endOf('day').isBefore(moment());
                                                                                        const isEtapeTerminee = etape.statut === 'Terminée';
                                                                                        const isModuleEvaluation = etape.module === 'Evaluation';
                                                                                        const isModuleRevision = etape.module === 'Revision';

                                                                                        return (
                                                                                            <tr key={etape.id}>
                                                                                                <td>{etape.titre}</td>
                                                                                                <td>{etape.date_echeance}</td>
                                                                                                <td>
                                                                                                    {/* Vérification si l'étape est terminée pour tous les utilisateurs, sauf si le module est "Evaluation" */}
                                                                                                    {etape.module !== "Evaluation" && etape.statut === "Terminée" ? (
                                                                                                        <span className="text-success">
                                                                                                            <i className="fa fa-check"></i>
                                                                                                        </span>
                                                                                                    ) : (etape.module === "Cours" || etape.module === "Autre") ? (
                                                                                                        <button
                                                                                                            onClick={() => terminerEtape(etape, etape.parcours_id)}
                                                                                                            className="btn p-1 btn-success"
                                                                                                            disabled={!etape || etape.module === "Evaluation" || etape.module === "Revision" || isLoadingTerminer}
                                                                                                        >
                                                                                                            {isLoadingTerminer ? 'Chargement..' : 'Terminer'}
                                                                                                        </button>
                                                                                                    ) : null}

                                                                                                    {/* Affichage du bouton "Détails" uniquement si le module est "Evaluation" */}
                                                                                                    {etape.module === "Evaluation" && (
                                                                                                        <button
                                                                                                            onClick={() => handleAfficherDetailsEtapeUtilisateursModal(etape.id, etape.parcours_id)}
                                                                                                            className="btn p-1 btn-success"
                                                                                                        >
                                                                                                            Détails
                                                                                                        </button>
                                                                                                    )}
                                                                                                </td>


                                                                                            </tr>
                                                                                        );
                                                                                    })}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>


                                                                        {/* Affichage des autres utilisateurs et de leur progression */}
                                                                        <div className="col-md-6 table-container">
                                                                            <table className="footable table table-stripped footable-loaded tablet breakpoint">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('nom')}>
                                                                                            Nom
                                                                                            {sortConfig.key === 'nom' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                                        </th>
                                                                                        <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('parcours')}>
                                                                                            Progrès
                                                                                            {sortConfig.key === 'parcours' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                                        </th>
                                                                                        <th className="text-secondary text-wrap d-none d-md-table-cell">Action</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {/* Affichage des données utilisateurs */}
                                                                                    {parcoursData.utilisateurs.map((user) => {
                                                                                        const retardProgression = user.fichiers[0]?.progression < pourcentageEtapesDepassees; // Calcul du retard de progression
                                                                                        const rowClass = retardProgression ? 'text-danger' : '';

                                                                                        return (
                                                                                            <tr key={user.utilisateur_id}>
                                                                                                <td>{user.utilisateur}</td>
                                                                                                <td className={rowClass}>{user.fichiers[0]?.progression}%</td>
                                                                                                <td>
                                                                                                    <button
                                                                                                        className="btn btn-success p-1"
                                                                                                        onClick={() => handleOuvrirProgressionParUtilisateur(user.fichiers[0]?.etapes, user.utilisateur, user.utilisateur_id, parcoursData.parcour_id)}
                                                                                                    >
                                                                                                        Détails
                                                                                                    </button>
                                                                                                </td>
                                                                                            </tr>
                                                                                        );
                                                                                    })}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>

                                                </div>

                                                <Modal show={detailsEtapeUtilisateursModal} onHide={handleFermerDetailsEtapeUtilisateursModal} size="lg">
                                                    <Modal.Header >
                                                        <Modal.Title>{listeDetailEtapeUtilisateurs[1]?.titre_etape}</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>

                                                        {loadingModalRang ? (
                                                            <div className="d-flex justify-content-center align-items-center h-100">
                                                                <div className="spiner-example">
                                                                    <div className="sk-spinner sk-spinner-wave">
                                                                        <div className="sk-rect1 mr-1"></div>
                                                                        <div className="sk-rect2 mr-1"></div>
                                                                        <div className="sk-rect3 mr-1"></div>
                                                                        <div className="sk-rect4 mr-1"></div>
                                                                        <div className="sk-rect5"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                {afficherDetail ? (
                                                                    <div>
                                                                        <h5>{etapeSelectionne?.titre}</h5>
                                                                        <div>
                                                                            {isLoadingEvaluation ? (
                                                                                <p>Chargement des données de l'évaluations...</p>
                                                                            ) : evaluation && evaluation.length > 0 ? (

                                                                                <div style={{ padding: "20px" }}>
                                                                                    {/* Si aucune évaluation n'est sélectionnée, on affiche la liste des évaluations */}
                                                                                    {selectedEvaluation === null ? (
                                                                                        <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                                                            <thead>
                                                                                                <tr>
                                                                                                    {/* <th>#</th> */}
                                                                                                    <th>Évaluation</th>
                                                                                                    <th>Nbre de questions traités</th>
                                                                                                    <th>Date</th>
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>
                                                                                                {evaluation.map((evalItem, evalIndex) => {
                                                                                                    const isOpen = openEvaluations[evalItem.evaluation_id];

                                                                                                    return (
                                                                                                        <React.Fragment key={evalItem.evaluation_id}>
                                                                                                            {/* Ligne principale de l'évaluation */}
                                                                                                            <tr
                                                                                                                style={{
                                                                                                                    cursor: "pointer",
                                                                                                                    backgroundColor: isOpen ? "#e8f5e9" : "#fff",
                                                                                                                    borderBottom: "1px solid #ddd",

                                                                                                                }}
                                                                                                                onMouseEnter={(e) => e.currentTarget.classList.add("bg-success")}
                                                                                                                onMouseLeave={(e) => e.currentTarget.classList.remove("bg-success")}
                                                                                                                onClick={() => selectEvaluation(evalItem.evaluation_id)}
                                                                                                            >
                                                                                                                <td style={{ padding: "10px" }}>
                                                                                                                    Évaluation <span className='badge badge-default'> {evalItem.evaluation_id} </span>
                                                                                                                </td>
                                                                                                                <td style={{ padding: "10px" }}>
                                                                                                                    {evalItem.qcm.length}
                                                                                                                </td>
                                                                                                                {/* <td style={{ padding: "10px" }}>{evalItem.evaluation_id}</td> */}
                                                                                                                <td style={{ padding: "10px" }}>{evalItem.date_heure}</td>
                                                                                                                {/* <td
                                                                                                                style={{
                                                                                                                    padding: "10px",
                                                                                                                    textAlign: "center",
                                                                                                                    fontSize: "16px",
                                                                                                                    color: "#555",
                                                                                                                }}
                                                                                                            >
                                                                                                                {selectedEvaluation === evalItem.evaluation_id ? "▲" : "▼"}
                                                                                                            </td> */}
                                                                                                            </tr>

                                                                                                            {/* Affichage des QCM si l'évaluation est sélectionnée */}
                                                                                                            {selectedEvaluation === evalItem.evaluation_id && (
                                                                                                                <tr>
                                                                                                                    <td colSpan="3" style={{ padding: "15px", backgroundColor: "#f9f9f9" }}>
                                                                                                                        {evalItem.qcm.map((qcm) => (
                                                                                                                            <div
                                                                                                                                key={qcm.id}
                                                                                                                                style={{
                                                                                                                                    borderBottom: "1px solid #ccc",
                                                                                                                                    marginBottom: "15px",
                                                                                                                                    paddingBottom: "15px",
                                                                                                                                }}
                                                                                                                            >
                                                                                                                                {/* Question */}
                                                                                                                                <div>
                                                                                                                                    <span># {qcm.id} - </span>
                                                                                                                                    <span
                                                                                                                                        id="question"
                                                                                                                                        style={{ fontSize: "13px" }}
                                                                                                                                        dangerouslySetInnerHTML={{
                                                                                                                                            __html: qcm.question,
                                                                                                                                        }}
                                                                                                                                    ></span>
                                                                                                                                </div>

                                                                                                                                {/* Options */}
                                                                                                                                <div style={{ margin: "10px 10px" }}>
                                                                                                                                    {Object.keys(qcm)
                                                                                                                                        .filter(
                                                                                                                                            (key) =>
                                                                                                                                                key.startsWith("option") &&
                                                                                                                                                qcm[key] &&
                                                                                                                                                qcm[key] !== "non défini"
                                                                                                                                        )
                                                                                                                                        .map((key, optionIndex) => {
                                                                                                                                            const optionLetter = String.fromCharCode(
                                                                                                                                                65 + optionIndex
                                                                                                                                            );
                                                                                                                                            const optionText = qcm[key];
                                                                                                                                            const isCorrectAnswer =
                                                                                                                                                Array.isArray(qcm.reponse) &&
                                                                                                                                                qcm.reponse.includes(optionLetter);
                                                                                                                                            const isUserAnswer =
                                                                                                                                                Array.isArray(qcm.resultat) &&
                                                                                                                                                qcm.resultat.includes(optionLetter);

                                                                                                                                            return (
                                                                                                                                                <div
                                                                                                                                                    key={key}
                                                                                                                                                    style={{
                                                                                                                                                        display: "flex",
                                                                                                                                                        alignItems: "center",
                                                                                                                                                        marginBottom: "10px",
                                                                                                                                                        fontSize: "12px",
                                                                                                                                                    }}
                                                                                                                                                >
                                                                                                                                                    <span style={{ marginRight: "2px" }}>
                                                                                                                                                        {optionLetter} - {optionText}
                                                                                                                                                    </span>

                                                                                                                                                    {isCorrectAnswer && isUserAnswer ? (
                                                                                                                                                        <i
                                                                                                                                                            className="fa fa-thumbs-o-up fa-2x"
                                                                                                                                                            style={{
                                                                                                                                                                color: "green",
                                                                                                                                                                marginLeft: "5px",
                                                                                                                                                            }}
                                                                                                                                                            title="Correct Answer (Selected)"
                                                                                                                                                        ></i>
                                                                                                                                                    ) : isUserAnswer && !isCorrectAnswer ? (
                                                                                                                                                        <i
                                                                                                                                                            className="fa fa-thumbs-o-down fa-2x"
                                                                                                                                                            style={{
                                                                                                                                                                color: "red",
                                                                                                                                                                marginLeft: "5px",
                                                                                                                                                            }}
                                                                                                                                                            title="Incorrect Answer (Selected)"
                                                                                                                                                        ></i>
                                                                                                                                                    ) : isCorrectAnswer ? (
                                                                                                                                                        <i
                                                                                                                                                            className="fa fa-thumbs-o-up fa-2x"
                                                                                                                                                            style={{
                                                                                                                                                                color: "green",
                                                                                                                                                                marginLeft: "5px",
                                                                                                                                                            }}
                                                                                                                                                            title="Correct Answer"
                                                                                                                                                        ></i>
                                                                                                                                                    ) : null}
                                                                                                                                                </div>
                                                                                                                                            );
                                                                                                                                        })}
                                                                                                                                </div>

                                                                                                                                {/* Explication (si elle existe) */}
                                                                                                                                {qcm.explication && qcm.explication !== "non défini" && (
                                                                                                                                    <div style={{ color: "green" }}>
                                                                                                                                        <span>Explication : </span>
                                                                                                                                        <span
                                                                                                                                            dangerouslySetInnerHTML={{
                                                                                                                                                __html: qcm.explication,
                                                                                                                                            }}
                                                                                                                                        />
                                                                                                                                    </div>
                                                                                                                                )}
                                                                                                                            </div>
                                                                                                                        ))}
                                                                                                                    </td>
                                                                                                                </tr>
                                                                                                            )}
                                                                                                        </React.Fragment>
                                                                                                    );
                                                                                                })}
                                                                                            </tbody>
                                                                                        </table>
                                                                                    ) : (
                                                                                        // Si une évaluation est sélectionnée, on affiche les QCM
                                                                                        evaluation
                                                                                            .filter((evalItem) => evalItem.evaluation_id === selectedEvaluation)
                                                                                            .map((evalItem) => (
                                                                                                <div key={evalItem.evaluation_id}>
                                                                                                    {evalItem.qcm.map((qcm) => (
                                                                                                        <div
                                                                                                            key={qcm.id}
                                                                                                            style={{
                                                                                                                borderBottom: "1px solid #ccc",
                                                                                                                marginBottom: "15px",
                                                                                                                paddingBottom: "15px",
                                                                                                            }}
                                                                                                        >
                                                                                                            {/* Question */}
                                                                                                            <div>
                                                                                                                <span># {qcm.id} - </span>
                                                                                                                <span
                                                                                                                    id="question"
                                                                                                                    style={{ fontSize: "13px" }}
                                                                                                                    dangerouslySetInnerHTML={{
                                                                                                                        __html: qcm.question,
                                                                                                                    }}
                                                                                                                ></span>
                                                                                                            </div>

                                                                                                            {/* Options */}
                                                                                                            <div style={{ margin: "10px 10px" }}>
                                                                                                                {Object.keys(qcm)
                                                                                                                    .filter(
                                                                                                                        (key) =>
                                                                                                                            key.startsWith("option") &&
                                                                                                                            qcm[key] &&
                                                                                                                            qcm[key] !== "non défini"
                                                                                                                    )
                                                                                                                    .map((key, optionIndex) => {
                                                                                                                        const optionLetter = String.fromCharCode(65 + optionIndex);
                                                                                                                        const optionText = qcm[key];
                                                                                                                        const isCorrectAnswer =
                                                                                                                            Array.isArray(qcm.reponse) &&
                                                                                                                            qcm.reponse.includes(optionLetter);
                                                                                                                        const isUserAnswer =
                                                                                                                            Array.isArray(qcm.resultat) &&
                                                                                                                            qcm.resultat.includes(optionLetter);

                                                                                                                        return (
                                                                                                                            <div
                                                                                                                                key={key}
                                                                                                                                style={{
                                                                                                                                    display: "flex",
                                                                                                                                    alignItems: "center",
                                                                                                                                    marginBottom: "10px",
                                                                                                                                    fontSize: "12px",
                                                                                                                                }}
                                                                                                                            >
                                                                                                                                <span style={{ marginRight: "2px" }}>
                                                                                                                                    {optionLetter} - {optionText}
                                                                                                                                </span>

                                                                                                                                {isCorrectAnswer && isUserAnswer ? (
                                                                                                                                    <i
                                                                                                                                        className="fa fa-thumbs-o-up fa-2x"
                                                                                                                                        style={{
                                                                                                                                            color: "green",
                                                                                                                                            marginLeft: "5px",
                                                                                                                                        }}
                                                                                                                                        title="Correct Answer (Selected)"
                                                                                                                                    ></i>
                                                                                                                                ) : isUserAnswer && !isCorrectAnswer ? (
                                                                                                                                    <i
                                                                                                                                        className="fa fa-thumbs-o-down fa-2x"
                                                                                                                                        style={{
                                                                                                                                            color: "red",
                                                                                                                                            marginLeft: "5px",
                                                                                                                                        }}
                                                                                                                                        title="Incorrect Answer (Selected)"
                                                                                                                                    ></i>
                                                                                                                                ) : isCorrectAnswer ? (
                                                                                                                                    <i
                                                                                                                                        className="fa fa-thumbs-o-up fa-2x"
                                                                                                                                        style={{
                                                                                                                                            color: "green",
                                                                                                                                            marginLeft: "5px",
                                                                                                                                        }}
                                                                                                                                        title="Correct Answer"
                                                                                                                                    ></i>
                                                                                                                                ) : null}
                                                                                                                            </div>
                                                                                                                        );
                                                                                                                    })}
                                                                                                            </div>

                                                                                                            {/* Explication (si elle existe) */}
                                                                                                            {qcm.explication && qcm.explication !== "non défini" && (
                                                                                                                <div style={{ color: "green" }}>
                                                                                                                    <span>Explication : </span>
                                                                                                                    <span
                                                                                                                        dangerouslySetInnerHTML={{
                                                                                                                            __html: qcm.explication,
                                                                                                                        }}
                                                                                                                    />
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </div>
                                                                                                    ))}
                                                                                                </div>
                                                                                            ))
                                                                                    )}
                                                                                </div>
                                                                            ) : (
                                                                                <p className="text-danger">L'apprenant {utilisateurNom} n'a pas encore traité l'évaluation.</p>
                                                                            )}

                                                                        </div>
                                                                    </div>

                                                                ) : (
                                                                    <div>
                                                                        <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th className='text-secondary text-wrap' onClick={() => handleSort('titre')}>
                                                                                        Utilisateurs
                                                                                    </th>
                                                                                    <th className='text-secondary text-wrap' onClick={() => handleSort('nbre_heure')}>
                                                                                        Statut
                                                                                    </th>
                                                                                    <th className='text-secondary text-wrap' onClick={() => handleSort('nbre_heure')}>
                                                                                        Score
                                                                                    </th>
                                                                                    <th className='text-secondary text-wrap' onClick={() => handleSort('nbre_heure')}>
                                                                                        Rang
                                                                                    </th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {itemsPageCourante.map((item) => (
                                                                                    <tr key={item.utilisateur}>
                                                                                        <td>{item.utilisateur}</td>
                                                                                        <td>
                                                                                            {item.etape.statut === 'Terminée' ? (
                                                                                                <span className="badge badge-success">{item.etape.statut}</span>
                                                                                            ) : (
                                                                                                <span className="badge badge-warning">En attente</span>
                                                                                            )}
                                                                                        </td>
                                                                                        <td>{item.etape.score}</td>
                                                                                        <td>{item.rang}</td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                                                            {/* Affichage de l'information sur la pagination */}
                                                                            <div className="dataTables_info" role="status" aria-live="polite">
                                                                                {listeDetailEtapeUtilisateurs.length === 0
                                                                                    ? "Aucun élément à afficher"
                                                                                    : `Élément ${pageCourante === 1 ? 1 : (pageCourante - 1) * nombreItemsParPage + 1} à ${pageCourante * nombreItemsParPage > listeDetailEtapeUtilisateurs.length ? listeDetailEtapeUtilisateurs.length : pageCourante * nombreItemsParPage} sur ${listeDetailEtapeUtilisateurs.length}`}
                                                                            </div>

                                                                            {/* Pagination avec les boutons */}
                                                                            <div>
                                                                                {/* Bouton Précédent */}
                                                                                <button
                                                                                    onClick={() => setPageCourante(pageCourante - 1)}
                                                                                    className={`btn ${pageCourante === 1 ? 'btn-default' : 'btn-light'} mx-1`}
                                                                                    disabled={pageCourante === 1}
                                                                                >
                                                                                    <i className="fa fa-chevron-left"></i> {/* Icône Précédent */}
                                                                                </button>

                                                                                {/* Numéros de page */}
                                                                                {numerosDePage.map((numero) => (
                                                                                    <button
                                                                                        key={numero}
                                                                                        onClick={() => changerPage(numero)}
                                                                                        className={`btn ${pageCourante === numero ? 'btn-default' : 'btn-light'} mx-1`}
                                                                                    >
                                                                                        {numero}
                                                                                    </button>
                                                                                ))}

                                                                                {/* Bouton Suivant */}
                                                                                <button
                                                                                    onClick={() => setPageCourante(pageCourante + 1)}
                                                                                    className={`btn ${pageCourante === totalPage ? 'btn-default' : 'btn-light'} mx-1`}
                                                                                    disabled={pageCourante === totalPage}
                                                                                >
                                                                                    <i className="fa fa-chevron-right"></i> {/* Icône Suivant */}
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}

                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        <Button variant="secondary" onClick={handleFermerDetailsEtapeUtilisateursModal}>
                                                            Fermer
                                                        </Button>
                                                    </Modal.Footer>
                                                </Modal>

                                                <Modal show={parcoursModal} onHide={handleFermerParcoursModal} size="lg">
                                                    <Modal.Header>
                                                        <Modal.Title>Liste des Parcours</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        {currentParcours.length > 0 ? (
                                                            <div className='ibox-content'>
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <div className="me-2">
                                                                        <select
                                                                            value={itemsParPageParcours}
                                                                            onChange={handleItemsParPageChange}
                                                                            className="form-select bg-default p-1"
                                                                            style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                                        >
                                                                            <option value={10}>10</option>
                                                                            <option value={20}>20</option>
                                                                            <option value={50}>50</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                                    <thead>
                                                                        <tr>
                                                                            <th className='text-secondary text-wrap' onClick={() => handleSort('titre')}>
                                                                                Titre {sortConfig.key === 'titre'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                            </th>
                                                                            <th className='text-secondary text-center' onClick={() => handleSort('nbre_heure')}>
                                                                                Heures {sortConfig.key === 'nbre_heure'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                            </th>
                                                                            <th className='text-secondary text-right'>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {currentParcours.map((parcours) => (
                                                                            <tr
                                                                                key={parcours.id}
                                                                                style={{
                                                                                    cursor: "pointer",
                                                                                }}
                                                                                className={
                                                                                    parcoursSelectionne?.id === parcours.id
                                                                                        ? "bg-success text-white"
                                                                                        : ""
                                                                                }
                                                                            >
                                                                                <td onClick={() => handleParcoursClick(parcours)}>{parcours.titre}</td>
                                                                                <td className='text-secondary text-center' onClick={() => handleParcoursClick(parcours)}>{parcours.nbre_heure}H</td>
                                                                                <td className='text-secondary text-right'>
                                                                                    <Button
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            demarrerParcours(parcours.id);
                                                                                        }}
                                                                                        disabled={loadingParcours[parcours.id]}
                                                                                        className="btn btn-success btn-sm"
                                                                                    >
                                                                                        {loadingParcours[parcours.id] ? 'Lancement...' : 'Rattacher'}
                                                                                    </Button>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                                <div className="d-flex justify-content-between align-items-center mt-3">
                                                                    <div className="dataTables_info" role="status" aria-live="polite">
                                                                        {totalItemsParcours === 0
                                                                            ? "Aucun élément à afficher"
                                                                            : `Élément ${currentPageParcours === 1 ? 1 : (currentPageParcours - 1) * itemsParPageParcours + 1} à ${currentPageParcours * itemsParPageParcours > totalItemsParcours ? totalItemsParcours : currentPageParcours * itemsParPageParcours
                                                                            } sur ${totalItemsParcours}`}
                                                                    </div>
                                                                    <div>
                                                                        {Array.from({ length: totalPagesParcours }, (_, index) => (
                                                                            <button
                                                                                key={index + 1}
                                                                                onClick={() => setCurrentPageParcours(index + 1)}
                                                                                className={`btn ${currentPageParcours === index + 1 ? 'btn-default' : 'btn-light'} mx-1`}
                                                                            >
                                                                                {index + 1}
                                                                            </button>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <p>Aucun parcours trouvé.</p>
                                                        )}
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        <Button variant="secondary" onClick={handleFermerParcoursModal}>
                                                            Fermer
                                                        </Button>
                                                    </Modal.Footer>
                                                </Modal>


                                                <Modal show={progressionParUtilisateur} onHide={handleFermerProgressionParUtilisateur} size="lg">
                                                    <Modal.Header className="d-block">
                                                        <Modal.Title>Parcours de {utilisateurNom}</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <div>
                                                            {afficherDetail ? (
                                                                <div>
                                                                    <h5>{etapeSelectionne?.titre}</h5>
                                                                    <div>
                                                                        {isLoadingEvaluation ? (
                                                                            <p>Chargement des données de l'évaluations...</p>
                                                                        ) : evaluation && evaluation.length > 0 ? (

                                                                            <div style={{ padding: "20px" }}>
                                                                                {/* Si aucune évaluation n'est sélectionnée, on affiche la liste des évaluations */}
                                                                                {selectedEvaluation === null ? (
                                                                                    <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                                                        <thead>
                                                                                            <tr>
                                                                                                {/* <th>#</th> */}
                                                                                                <th>Évaluation</th>
                                                                                                <th>Nbre de questions traités</th>
                                                                                                <th>Date</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {evaluation.map((evalItem, evalIndex) => {
                                                                                                const isOpen = openEvaluations[evalItem.evaluation_id];

                                                                                                return (
                                                                                                    <React.Fragment key={evalItem.evaluation_id}>
                                                                                                        {/* Ligne principale de l'évaluation */}
                                                                                                        <tr
                                                                                                            style={{
                                                                                                                cursor: "pointer",
                                                                                                                backgroundColor: isOpen ? "#e8f5e9" : "#fff",
                                                                                                                borderBottom: "1px solid #ddd",

                                                                                                            }}
                                                                                                            onMouseEnter={(e) => e.currentTarget.classList.add("bg-success")}
                                                                                                            onMouseLeave={(e) => e.currentTarget.classList.remove("bg-success")}
                                                                                                            onClick={() => selectEvaluation(evalItem.evaluation_id)}
                                                                                                        >
                                                                                                            <td style={{ padding: "10px" }}>
                                                                                                                Évaluation <span className='badge badge-default'> {evalItem.evaluation_id} </span>
                                                                                                            </td>
                                                                                                            <td style={{ padding: "10px" }}>
                                                                                                                {evalItem.qcm.length}
                                                                                                            </td>
                                                                                                            {/* <td style={{ padding: "10px" }}>{evalItem.evaluation_id}</td> */}
                                                                                                            <td style={{ padding: "10px" }}>{evalItem.date_heure}</td>
                                                                                                            {/* <td
                                                                                                                style={{
                                                                                                                    padding: "10px",
                                                                                                                    textAlign: "center",
                                                                                                                    fontSize: "16px",
                                                                                                                    color: "#555",
                                                                                                                }}
                                                                                                            >
                                                                                                                {selectedEvaluation === evalItem.evaluation_id ? "▲" : "▼"}
                                                                                                            </td> */}
                                                                                                        </tr>

                                                                                                        {/* Affichage des QCM si l'évaluation est sélectionnée */}
                                                                                                        {selectedEvaluation === evalItem.evaluation_id && (
                                                                                                            <tr>
                                                                                                                <td colSpan="3" style={{ padding: "15px", backgroundColor: "#f9f9f9" }}>
                                                                                                                    {evalItem.qcm.map((qcm) => (
                                                                                                                        <div
                                                                                                                            key={qcm.id}
                                                                                                                            style={{
                                                                                                                                borderBottom: "1px solid #ccc",
                                                                                                                                marginBottom: "15px",
                                                                                                                                paddingBottom: "15px",
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            {/* Question */}
                                                                                                                            <div>
                                                                                                                                <span># {qcm.id} - </span>
                                                                                                                                <span
                                                                                                                                    id="question"
                                                                                                                                    style={{ fontSize: "13px" }}
                                                                                                                                    dangerouslySetInnerHTML={{
                                                                                                                                        __html: qcm.question,
                                                                                                                                    }}
                                                                                                                                ></span>
                                                                                                                            </div>

                                                                                                                            {/* Options */}
                                                                                                                            <div style={{ margin: "10px 10px" }}>
                                                                                                                                {Object.keys(qcm)
                                                                                                                                    .filter(
                                                                                                                                        (key) =>
                                                                                                                                            key.startsWith("option") &&
                                                                                                                                            qcm[key] &&
                                                                                                                                            qcm[key] !== "non défini"
                                                                                                                                    )
                                                                                                                                    .map((key, optionIndex) => {
                                                                                                                                        const optionLetter = String.fromCharCode(
                                                                                                                                            65 + optionIndex
                                                                                                                                        );
                                                                                                                                        const optionText = qcm[key];
                                                                                                                                        const isCorrectAnswer =
                                                                                                                                            Array.isArray(qcm.reponse) &&
                                                                                                                                            qcm.reponse.includes(optionLetter);
                                                                                                                                        const isUserAnswer =
                                                                                                                                            Array.isArray(qcm.resultat) &&
                                                                                                                                            qcm.resultat.includes(optionLetter);

                                                                                                                                        return (
                                                                                                                                            <div
                                                                                                                                                key={key}
                                                                                                                                                style={{
                                                                                                                                                    display: "flex",
                                                                                                                                                    alignItems: "center",
                                                                                                                                                    marginBottom: "10px",
                                                                                                                                                    fontSize: "12px",
                                                                                                                                                }}
                                                                                                                                            >
                                                                                                                                                <span style={{ marginRight: "2px" }}>
                                                                                                                                                    {optionLetter} - {optionText}
                                                                                                                                                </span>

                                                                                                                                                {isCorrectAnswer && isUserAnswer ? (
                                                                                                                                                    <i
                                                                                                                                                        className="fa fa-thumbs-o-up fa-2x"
                                                                                                                                                        style={{
                                                                                                                                                            color: "green",
                                                                                                                                                            marginLeft: "5px",
                                                                                                                                                        }}
                                                                                                                                                        title="Correct Answer (Selected)"
                                                                                                                                                    ></i>
                                                                                                                                                ) : isUserAnswer && !isCorrectAnswer ? (
                                                                                                                                                    <i
                                                                                                                                                        className="fa fa-thumbs-o-down fa-2x"
                                                                                                                                                        style={{
                                                                                                                                                            color: "red",
                                                                                                                                                            marginLeft: "5px",
                                                                                                                                                        }}
                                                                                                                                                        title="Incorrect Answer (Selected)"
                                                                                                                                                    ></i>
                                                                                                                                                ) : isCorrectAnswer ? (
                                                                                                                                                    <i
                                                                                                                                                        className="fa fa-thumbs-o-up fa-2x"
                                                                                                                                                        style={{
                                                                                                                                                            color: "green",
                                                                                                                                                            marginLeft: "5px",
                                                                                                                                                        }}
                                                                                                                                                        title="Correct Answer"
                                                                                                                                                    ></i>
                                                                                                                                                ) : null}
                                                                                                                                            </div>
                                                                                                                                        );
                                                                                                                                    })}
                                                                                                                            </div>

                                                                                                                            {/* Explication (si elle existe) */}
                                                                                                                            {qcm.explication && qcm.explication !== "non défini" && (
                                                                                                                                <div style={{ color: "green" }}>
                                                                                                                                    <span>Explication : </span>
                                                                                                                                    <span
                                                                                                                                        dangerouslySetInnerHTML={{
                                                                                                                                            __html: qcm.explication,
                                                                                                                                        }}
                                                                                                                                    />
                                                                                                                                </div>
                                                                                                                            )}
                                                                                                                        </div>
                                                                                                                    ))}
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        )}
                                                                                                    </React.Fragment>
                                                                                                );
                                                                                            })}
                                                                                        </tbody>
                                                                                    </table>
                                                                                ) : (
                                                                                    // Si une évaluation est sélectionnée, on affiche les QCM
                                                                                    evaluation
                                                                                        .filter((evalItem) => evalItem.evaluation_id === selectedEvaluation)
                                                                                        .map((evalItem) => (
                                                                                            <div key={evalItem.evaluation_id}>
                                                                                                {evalItem.qcm.map((qcm) => (
                                                                                                    <div
                                                                                                        key={qcm.id}
                                                                                                        style={{
                                                                                                            borderBottom: "1px solid #ccc",
                                                                                                            marginBottom: "15px",
                                                                                                            paddingBottom: "15px",
                                                                                                        }}
                                                                                                    >
                                                                                                        {/* Question */}
                                                                                                        <div>
                                                                                                            <span># {qcm.id} - </span>
                                                                                                            <span
                                                                                                                id="question"
                                                                                                                style={{ fontSize: "13px" }}
                                                                                                                dangerouslySetInnerHTML={{
                                                                                                                    __html: qcm.question,
                                                                                                                }}
                                                                                                            ></span>
                                                                                                        </div>

                                                                                                        {/* Options */}
                                                                                                        <div style={{ margin: "10px 10px" }}>
                                                                                                            {Object.keys(qcm)
                                                                                                                .filter(
                                                                                                                    (key) =>
                                                                                                                        key.startsWith("option") &&
                                                                                                                        qcm[key] &&
                                                                                                                        qcm[key] !== "non défini"
                                                                                                                )
                                                                                                                .map((key, optionIndex) => {
                                                                                                                    const optionLetter = String.fromCharCode(65 + optionIndex);
                                                                                                                    const optionText = qcm[key];
                                                                                                                    const isCorrectAnswer =
                                                                                                                        Array.isArray(qcm.reponse) &&
                                                                                                                        qcm.reponse.includes(optionLetter);
                                                                                                                    const isUserAnswer =
                                                                                                                        Array.isArray(qcm.resultat) &&
                                                                                                                        qcm.resultat.includes(optionLetter);

                                                                                                                    return (
                                                                                                                        <div
                                                                                                                            key={key}
                                                                                                                            style={{
                                                                                                                                display: "flex",
                                                                                                                                alignItems: "center",
                                                                                                                                marginBottom: "10px",
                                                                                                                                fontSize: "12px",
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            <span style={{ marginRight: "2px" }}>
                                                                                                                                {optionLetter} - {optionText}
                                                                                                                            </span>

                                                                                                                            {isCorrectAnswer && isUserAnswer ? (
                                                                                                                                <i
                                                                                                                                    className="fa fa-thumbs-o-up fa-2x"
                                                                                                                                    style={{
                                                                                                                                        color: "green",
                                                                                                                                        marginLeft: "5px",
                                                                                                                                    }}
                                                                                                                                    title="Correct Answer (Selected)"
                                                                                                                                ></i>
                                                                                                                            ) : isUserAnswer && !isCorrectAnswer ? (
                                                                                                                                <i
                                                                                                                                    className="fa fa-thumbs-o-down fa-2x"
                                                                                                                                    style={{
                                                                                                                                        color: "red",
                                                                                                                                        marginLeft: "5px",
                                                                                                                                    }}
                                                                                                                                    title="Incorrect Answer (Selected)"
                                                                                                                                ></i>
                                                                                                                            ) : isCorrectAnswer ? (
                                                                                                                                <i
                                                                                                                                    className="fa fa-thumbs-o-up fa-2x"
                                                                                                                                    style={{
                                                                                                                                        color: "green",
                                                                                                                                        marginLeft: "5px",
                                                                                                                                    }}
                                                                                                                                    title="Correct Answer"
                                                                                                                                ></i>
                                                                                                                            ) : null}
                                                                                                                        </div>
                                                                                                                    );
                                                                                                                })}
                                                                                                        </div>

                                                                                                        {/* Explication (si elle existe) */}
                                                                                                        {qcm.explication && qcm.explication !== "non défini" && (
                                                                                                            <div style={{ color: "green" }}>
                                                                                                                <span>Explication : </span>
                                                                                                                <span
                                                                                                                    dangerouslySetInnerHTML={{
                                                                                                                        __html: qcm.explication,
                                                                                                                    }}
                                                                                                                />
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>
                                                                                        ))
                                                                                )}
                                                                            </div>
                                                                        ) : (
                                                                            <p className="text-danger">L'apprenant {utilisateurNom} n'a pas encore traité l'évaluation.</p>
                                                                        )}

                                                                    </div>
                                                                </div>

                                                            ) : (
                                                                // Sinon, afficher le tableau principal
                                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>#</th>
                                                                            <th>Titre</th>
                                                                            <th className='text-center'>Score</th>
                                                                            <th className='text-center'>Statut</th>
                                                                            <th className='text-center'>Date échéance</th>
                                                                            <th className='text-right'>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {etapesUtilisateur.map((etape) => {
                                                                            // Vérifier si la date d'échéance est dépassée
                                                                            const dateEcheance = new Date(etape.date_echeance.split('/').reverse().join('-'));
                                                                            const now = new Date();
                                                                            const isEcheanceDepassee = dateEcheance < now;

                                                                            // Vérifier si l'étape est terminée
                                                                            const isEtapeTerminee = etape.statut === 'Terminée';

                                                                            // Appliquer la ligne rouge uniquement si la date est dépassée et que l'étape n'est pas terminée
                                                                            const rowClass = isEcheanceDepassee && !isEtapeTerminee ? 'text-danger' : '';

                                                                            return (
                                                                                <tr key={etape.id} className={rowClass}>
                                                                                    <td>{etape.numero}</td>
                                                                                    <td>{etape.titre}</td>
                                                                                    <td className='text-center'>{etape.score}</td>
                                                                                    <td className='text-center'>
                                                                                        {isEtapeTerminee ? (
                                                                                            <span className="badge badge-success">{etape.statut}</span>
                                                                                        ) : (
                                                                                            <span className="badge badge-warning">En attente</span>
                                                                                        )}
                                                                                    </td>
                                                                                    <td className='text-center'>{etape.date_echeance}</td>
                                                                                    <td className='text-right'>
                                                                                        {(etape.module === 'Evaluation' && isEtapeTerminee) && (
                                                                                            <button className="btn btn-success p-1" onClick={() => handleVoirClick(etape)}>
                                                                                                Voir
                                                                                            </button>
                                                                                        )}
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })}
                                                                    </tbody>
                                                                </table>
                                                            )}
                                                        </div>
                                                        <div className='text-right mt-4'>
                                                            {selectedEvaluation ? (
                                                                <Button variant="secondary" onClick={handleRetourSurEveluation}>
                                                                    <FaArrowLeft /> Retour
                                                                </Button>
                                                            ) : (
                                                                <>
                                                                    {/* Si on est dans la vue détaillée, afficher le bouton retour */}
                                                                    {afficherDetail ? (
                                                                        <Button variant="secondary" onClick={handleRetour}>
                                                                            Retour
                                                                        </Button>
                                                                    ) : (
                                                                        // Si aucune évaluation n'est sélectionnée, afficher "Annuler"
                                                                        <Button variant="secondary" onClick={handleFermerProgressionParUtilisateur}>
                                                                            Annuler
                                                                        </Button>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    </Modal.Body>
                                                </Modal>
                                            </div>
                                        )}

                                        {activeSection === 'acces' && (
                                            <div className="" key={JSON.stringify(acces)}>
                                                <div className='ibox-title'>
                                                    <h4>Définir les Accès</h4>
                                                </div>
                                                <div className='ibox-content'>
                                                    {/* Accès Utilisateurs */}
                                                    <div className='mb-5'>
                                                        <div className=" mb-3">
                                                            <h3>Accès Utilisateurs</h3>
                                                            <div className="d-flex align-items-center gap-2">
                                                                <Form.Group className="mb-0">
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Tous sélectionner"
                                                                        className="fw-bold"
                                                                        checked={
                                                                            acces.Dashboard &&
                                                                            acces.eligibilite &&
                                                                            acces.Simulation &&
                                                                            acces.Quiz &&
                                                                            acces.EtudeDeCas &&
                                                                            acces.Apprentisage &&
                                                                            acces.ExamenBlanc &&
                                                                            acces.UtilisateurPartenaire
                                                                        }
                                                                        onChange={(e) => {
                                                                            const isChecked = e.target.checked;
                                                                            setAcces(prev => ({
                                                                                ...prev,
                                                                                Dashboard: isChecked,
                                                                                eligibilite: isChecked,
                                                                                Simulation: isChecked,
                                                                                Quiz: isChecked,
                                                                                EtudeDeCas: isChecked,
                                                                                Apprentisage: isChecked,
                                                                                ExamenBlanc: isChecked,
                                                                                UtilisateurPartenaire: isChecked
                                                                            }));
                                                                        }}
                                                                    />
                                                                </Form.Group>
                                                                {/* <small className="text-muted">(Tout sélectionner/désélectionner)</small> */}
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Dashboard"
                                                                        name="Dashboard"
                                                                        checked={acces.Dashboard}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                            <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Eligibilité"
                                                                        name="eligibilite"
                                                                        checked={acces.eligibilite}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                            <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Simulation"
                                                                        name="Simulation"
                                                                        checked={acces.Simulation}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-md-4 col-sm-6 col-12 mb-3">
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Quiz"
                                                                        name="Quiz"
                                                                        checked={acces.Quiz}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                            <div className="col-md-4 col-sm-6 col-12 mb-3">
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Étude de cas"
                                                                        name="EtudeDeCas"
                                                                        checked={acces.EtudeDeCas}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                            <div className="col-md-4 col-sm-6 col-12 mb-3">
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Parcours"
                                                                        name="Apprentisage"
                                                                        checked={acces.Apprentisage}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Examen Blanc"
                                                                        name="ExamenBlanc"
                                                                        checked={acces.ExamenBlanc}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                            <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Partenaire"
                                                                        name="UtilisateurPartenaire"
                                                                        checked={acces.UtilisateurPartenaire}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Accès Administrateurs */}
                                                    {(!userData.coach_groupe || userData.coach_groupe === "") && (
                                                        <div>
                                                            <div className="mb-3">
                                                                <h3>Accès Administrateurs / Coach</h3>
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <Form.Group className="mb-0">
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Tous sélectionner"
                                                                            className="fw-bold"
                                                                            checked={
                                                                                acces.Utilisateurs &&
                                                                                acces.Inscription &&
                                                                                // acces.Produits &&
                                                                                acces.Groupes &&
                                                                                acces.Formation &&
                                                                                acces.QCM &&
                                                                                acces.Administration &&
                                                                                acces.Parcours &&
                                                                                acces.ListeDeDiffusion &&
                                                                                acces.Notification &&
                                                                                acces.AdminExamenBlanc &&
                                                                                acces.AdminQuiz &&
                                                                                acces.AdminEligibilite &&
                                                                                acces.AdminEtudeDeCas &&
                                                                                acces.Partenaire &&
                                                                                acces.Souscription &&
                                                                                acces.Journalisation &&
                                                                                acces.AdminRdv &&
                                                                                acces.CoachRdv
                                                                            }
                                                                            onChange={(e) => {
                                                                                const isChecked = e.target.checked;
                                                                                setAcces(prev => ({
                                                                                    ...prev,
                                                                                    Utilisateurs: isChecked,
                                                                                    Inscription: isChecked,
                                                                                    // Produits: isChecked,
                                                                                    Groupes: isChecked,
                                                                                    Formation: isChecked,
                                                                                    QCM: isChecked,
                                                                                    Administration: isChecked,
                                                                                    Parcours: isChecked,
                                                                                    ListeDeDiffusion: isChecked,
                                                                                    Notification: isChecked,
                                                                                    AdminExamenBlanc: isChecked,
                                                                                    AdminQuiz: isChecked,
                                                                                    AdminEligibilite: isChecked,
                                                                                    AdminEtudeDeCas: isChecked,
                                                                                    Partenaire: isChecked,
                                                                                    Souscription: isChecked,
                                                                                    Journalisation: isChecked,
                                                                                    AdminRdv: isChecked,
                                                                                    CoachRdv: isChecked
                                                                                }));
                                                                            }}
                                                                        />
                                                                    </Form.Group>
                                                                    {/* <small className="text-muted">(Tout sélectionner/désélectionner)</small> */}
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Utilisateurs"
                                                                            name="Utilisateurs"
                                                                            checked={acces.Utilisateurs}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                                <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Inscription"
                                                                            name="Inscription"
                                                                            checked={acces.Inscription}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                                {/* <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Produits"
                                                                            name="Produits"
                                                                            checked={acces.Produits}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div> */}
                                                                <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Formation"
                                                                            name="Formation"
                                                                            checked={acces.Formation}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Groupes"
                                                                            name="Groupes"
                                                                            checked={acces.Groupes}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                                <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="QCM"
                                                                            name="QCM"
                                                                            checked={acces.QCM}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                                <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Administration"
                                                                            name="Administration"
                                                                            checked={acces.Administration}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className="col-md-4 col-sm-6 col-12 mb-3">
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Parcours"
                                                                            name="Parcours"
                                                                            checked={acces.Parcours}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                                <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Liste de diffusion"
                                                                            name="ListeDeDiffusion"
                                                                            checked={acces.ListeDeDiffusion}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                                <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Notification"
                                                                            name="Notification"
                                                                            checked={acces.Notification}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Examen Blanc Admin"
                                                                            name="AdminExamenBlanc"
                                                                            checked={acces.AdminExamenBlanc}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                                <div className="col-md-4 col-sm-6 col-12 mb-3">
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="AdminQuiz"
                                                                            name="AdminQuiz"
                                                                            checked={acces.AdminQuiz}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                                <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Eligibilite Admin"
                                                                            name="AdminEligibilite"
                                                                            checked={acces.AdminEligibilite}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Etude de cas"
                                                                            name="AdminEtudeDeCas"
                                                                            checked={acces.AdminEtudeDeCas}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                                <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Partenaire"
                                                                            name="Partenaire"
                                                                            checked={acces.Partenaire}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                                <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Souscription"
                                                                            name="Souscription"
                                                                            checked={acces.Souscription}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Journalisation"
                                                                            name="Journalisation"
                                                                            checked={acces.Journalisation}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                                <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Booking admin"
                                                                            name="AdminRdv"
                                                                            checked={acces.AdminRdv}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                                <div className='col-md-4 col-sm-6 col-12 mb-3'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Booking coach"
                                                                            name="CoachRdv"
                                                                            checked={acces.CoachRdv}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Buttons */}
                                                <div className="d-flex justify-content-center mt-4">
                                                    <button
                                                        onClick={handleSave}
                                                        disabled={isLoadingAcces}
                                                        type="submit"
                                                        className="btn btn-success block"
                                                    >
                                                        {isLoadingAcces ? 'Enregistrement...' : 'Enregistrer'}
                                                    </button>
                                                </div>
                                            </div>
                                        )}

                                        {activeSection === 'coach' && (
                                            <div className="container ibox">
                                                <div className="ibox-title d-flex align-items-center">
                                                    <h4>Coach</h4>
                                                </div>
                                                <div className="ibox-content">
                                                    <div className="row justify-content-center">
                                                        {/* Liste des coachs disponibles */}
                                                        <div className="col-md-4">
                                                            {/* Rechercher */}
                                                            <div className="d-flex mb-4">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Rechercher ici..."
                                                                    value={searchCoach}
                                                                    onChange={(e) => setSearchCoach(e.target.value)}
                                                                />
                                                            </div>
                                                            <h5>Coachs disponibles</h5>
                                                            <select
                                                                multiple
                                                                value={selectedAvailableCoaches}
                                                                onChange={(e) =>
                                                                    setSelectedAvailableCoaches(
                                                                        [...e.target.selectedOptions].map(option => parseInt(option.value))
                                                                    )
                                                                }
                                                                className="form-control"
                                                                style={dropdownStyles}
                                                            >
                                                                {filteredAllCoachs.map(coach => (
                                                                    <option key={coach.id} value={coach.id}>
                                                                        {coach.nom} {coach.prenoms}
                                                                    </option>
                                                                ))}
                                                            </select>

                                                        </div>

                                                        {/* Boutons d'actions pour gérer les coachs */}
                                                        <div className="col-md-3 d-flex flex-column justify-content-center">
                                                            <button
                                                                onClick={() => handleAssignerCoach()}
                                                                className="btn btn-success mb-2"
                                                            // disabled={!selectedAvailableCoaches.length}
                                                            >
                                                                Assigner <FaChevronRight />
                                                            </button>
                                                            <button
                                                                onClick={() => handleDesassignerCoach()}
                                                                className="btn btn-success"
                                                            // disabled={!selectedGroupCoaches.length}
                                                            >
                                                                <FaChevronLeft /> Retirer
                                                            </button>
                                                        </div>

                                                        {/* Liste des coachs assignés */}
                                                        <div className="col-md-4">
                                                            {/* Rechercher */}
                                                            <div className="d-flex mb-4">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Rechercher un coach assigné..."
                                                                    value={searchGroupCoach}
                                                                    onChange={(e) => setSearchGroupCoach(e.target.value)}
                                                                />
                                                            </div>
                                                            <h5>Coachs du groupe</h5>
                                                            <select
                                                                multiple
                                                                value={selectedGroupCoaches}
                                                                onChange={(e) =>
                                                                    setSelectedGroupCoaches(
                                                                        [...e.target.selectedOptions].map(option => parseInt(option.value))
                                                                    )
                                                                }
                                                                className="form-control"
                                                                style={dropdownStyles}
                                                            >
                                                                {filteredGroupeCoach.map(coach => (
                                                                    <option key={coach.id} value={coach.id}>
                                                                        {coach.nom} {coach.prenoms}
                                                                    </option>
                                                                ))}
                                                            </select>

                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <div className="ibox-content">
                <div className="text-right">
                    <button
                        onClick={() => handleAssignerCoach()}
                        className="btn btn-success mr-2"
                        // disabled={!selectedAvailableCoaches.length}
                    >
                        Assigner Coach
                    </button>
                    <button
                        onClick={() => handleDesassignerCoach()}
                        className="btn btn-danger"
                        // disabled={!selectedGroupCoaches.length}
                    >
                        Désassigner Coach
                    </button>
                </div>

                {groupCoaches.length > 0 ? (
                    <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                        <thead>
                            <tr>
                                <th>Nom</th>
                                <th>Prénoms</th>
                                <th>Email</th>
                            </tr>
                        </thead>
                        <tbody>
                            {groupCoaches.map(coach => (
                                <tr
                                    key={coach.id}
                                    onClick={() => handleCoachClick(coach)}
                                    style={{ cursor: "pointer" }}
                                    className={selectedGroupCoaches.includes(coach.id) ? "bg-success text-white" : ""}
                                >
                                    <td>{coach.nom}</td>
                                    <td>{coach.prenoms}</td>
                                    <td>{coach.email}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <p>Aucun coach assigné au groupe.</p>
                )}
            </div> */}
                                            </div>
                                        )}

                                        {activeSection === 'membres' && (
                                            <div>
                                                <div className='ibox-title'>
                                                    <h4>Gérer les membres du groupe</h4>
                                                </div>
                                                <div className='ibox-content'>

                                                    {/* Liste des utilisateurs déjà ajoutés au groupe */}
                                                    <div className="row justify-content-center">
                                                        <div className="col-md-4">
                                                            {/* Recherche d'utilisateurs */}
                                                            <div className="d-flex mb-4">
                                                                <input
                                                                    type="text"
                                                                    placeholder="Rechercher..."
                                                                    value={searchAll}
                                                                    onChange={(e) => setSearchAll(e.target.value)}
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                            <h5>Utilisateurs disponibles</h5>
                                                            <select
                                                                multiple
                                                                value={selectedAllUsers}
                                                                onChange={(e) => setSelectedAllUsers([...e.target.selectedOptions].map(option => parseInt(option.value)))}
                                                                className="form-control"
                                                                style={{
                                                                    height: '320px',
                                                                    padding: '10px',
                                                                    borderRadius: '8px',
                                                                    border: '1px solid #ccc',
                                                                    backgroundColor: '#f9f9f9',
                                                                    color: '#333',
                                                                    fontSize: '16px',
                                                                    marginBottom: '20px',
                                                                }}
                                                            >
                                                                {filteredAllUsers.map(user => (
                                                                    <option key={user.id} value={user.id}>
                                                                        {user.nom} {user.prenoms}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {/* Boutons d'actions pour ajouter ou retirer des utilisateurs */}
                                                        <div className="col-md-4 d-flex flex-column justify-content-center">
                                                            {/* <button onClick={ajouterTous} className="btn btn-dark mb-2">
                                                                {"Ajouter tous >>"}
                                                            </button> */}
                                                            <button onClick={ajouterSelection} className="btn btn-dark mb-2">
                                                                {"Ajouter sélection >"}
                                                            </button>
                                                            <button onClick={retirerSelection} className="btn btn-dark mb-2">
                                                                {"< Retirer sélection"}
                                                            </button>
                                                            {/* <button onClick={retirerTous} className="btn btn-dark">
                                                                {"<< Retirer tous"}
                                                            </button> */}
                                                        </div>

                                                        {/* Liste des utilisateurs disponibles à ajouter */}
                                                        <div className="col-md-4">
                                                            {/* Recherche d'utilisateurs */}
                                                            <div className="d-flex mb-4">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Rechercher..."
                                                                    value={searchGroupe}
                                                                    onChange={(e) => setSearchGroupe(e.target.value)}
                                                                />
                                                            </div>
                                                            <h5>Utilisateurs du groupe</h5>
                                                            <select
                                                                multiple
                                                                value={selectedGroupeUsers}
                                                                onChange={(e) => setSelectedGroupeUsers([...e.target.selectedOptions].map(option => parseInt(option.value)))}
                                                                className="form-control"
                                                                style={{
                                                                    height: '320px',
                                                                    padding: '10px',
                                                                    borderRadius: '8px',
                                                                    border: '1px solid #ccc',
                                                                    backgroundColor: '#f9f9f9',
                                                                    color: '#333',
                                                                    fontSize: '16px',
                                                                    marginBottom: '20px',
                                                                }}
                                                            >
                                                                {filteredGroupeUsers.map(user => (
                                                                    <option key={user.id} value={user.id}>
                                                                        {user.nom} {user.prenoms}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>


                                                {/* Formulaire pour enregistrer les modifications */}
                                                <div className="d-flex justify-content-center mt-4">
                                                    <button
                                                        onClick={handleSubmit}
                                                        disabled={isLoadingMembre}
                                                        type="submit"
                                                        className="btn btn-success block"
                                                    >
                                                        {isLoadingMembre ? 'Enregistrement...' : 'Enregistrer'}
                                                    </button>
                                                </div>
                                                {/* <div className="text-center mt-4">
                                                    <button onClick={handleSubmit} className="btn btn-success">
                                                        Enregistrer
                                                    </button>
                                                </div> */}
                                            </div>
                                        )}

                                        {activeSection === 'KPI' && (
                                            <div className="ibox-content">
                                                <h4>Indicateurs Clés de Performance (KPI)</h4>

                                                {!verifierParcoursExistant() ? (
                                                    <div className="alert alert-warning">
                                                        <i className="fa fa-exclamation-triangle mr-2"></i>
                                                        Aucun parcours n'a été assigné à ce groupe. Les KPI ne peuvent pas être calculés.
                                                    </div>
                                                ) : (
                                                    <>
                                                        <table className="table table-bordered">
                                                            <thead className="thead-light">
                                                                <tr>
                                                                    <th>Indicateur</th>
                                                                    <th>Cible</th>
                                                                    <th>Résultat actuel</th>
                                                                    <th>Statut</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {/* Taux de participation */}
                                                                <tr>
                                                                    <td>Taux de participation</td>
                                                                    <td>≥ 90%</td>
                                                                    <td>{groupeData.nbre_apprenant > 0 ? Math.round((groupeUsers.length / groupeData.nbre_apprenant) * 100) : 0}%</td>
                                                                    <td>
                                                                        <span className={`badge ${groupeData.nbre_apprenant > 0 && (groupeUsers.length / groupeData.nbre_apprenant) * 100 >= 90 ? 'badge-success' : 'badge-danger'}`}>
                                                                            {groupeData.nbre_apprenant > 0 && (groupeUsers.length / groupeData.nbre_apprenant) * 100 >= 90 ?
                                                                                <><i className="fa fa-check"></i> OK</> :
                                                                                <><i className="fa fa-times"></i> Non-atteint</>
                                                                            }
                                                                        </span>
                                                                    </td>
                                                                </tr>

                                                                {/* Taux de satisfaction */}
                                                                {/* Satisfaction client */}
                                                                <tr>
                                                                    <td>Taux de satisfaction client</td>
                                                                    <td>≥ 80%</td>
                                                                    <td>
                                                                        {loadingMoyenneAvis ? (
                                                                            <span className="text-muted">Calcul en cours...</span>
                                                                        ) : moyenneAvisClient ? (
                                                                            <span>
                                                                                {moyenneAvisClient.moyenne_pourcentage || 0}%
                                                                                {/* {moyenneAvisClient.moyenne_5 && (
                                                                                    <small className="text-muted ml-2">
                                                                                        ({moyenneAvisClient.moyenne_5}/5)
                                                                                    </small>
                                                                                )} */}
                                                                            </span>
                                                                        ) : (
                                                                            <span className="text-muted">Données indisponibles</span>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {loadingMoyenneAvis ? (
                                                                            <span className="badge badge-warning">
                                                                                <i className="fa fa-spinner fa-spin mr-1"></i> Chargement
                                                                            </span>
                                                                        ) : moyenneAvisClient && moyenneAvisClient.moyenne_pourcentage ? (
                                                                            <span className={`badge ${moyenneAvisClient.moyenne_pourcentage >= 80 ? 'badge-success' : 'badge-danger'}`}>
                                                                                {moyenneAvisClient.moyenne_pourcentage >= 80 ?
                                                                                    <><i className="fa fa-check"></i> OK</> :
                                                                                    <><i className="fa fa-times"></i> Non-atteint</>
                                                                                }
                                                                            </span>
                                                                        ) : (
                                                                            <span className="badge badge-secondary">N/A</span>
                                                                        )}
                                                                    </td>
                                                                </tr>

                                                                {/* Note pédagogie instructeur */}
                                                                <tr>
                                                                    <td>Note pédagogie instructeur</td>
                                                                    <td>≥ 4.5/5</td>
                                                                    <td>
                                                                        {loadingMoyenneAvis ? (
                                                                            <span className="text-muted">Calcul en cours...</span>
                                                                        ) : moyenneAvisClient && moyenneAvisClient.total_reponses > 0 ? (
                                                                            <span>
                                                                                {moyenneAvisClient.moyenne_5 || '0'}/5
                                                                                {/* <small className="text-muted ml-2">
                    ({moyenneAvisClient.moyenne_pourcentage || '0'}%)
                </small> */}
                                                                            </span>
                                                                        ) : (
                                                                            <span className="text-muted">Données indisponibles</span>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {loadingMoyenneAvis ? (
                                                                            <span className="badge badge-warning">
                                                                                <i className="fa fa-spinner fa-spin mr-1"></i> Chargement
                                                                            </span>
                                                                        ) : moyenneAvisClient && moyenneAvisClient.moyenne_5 ? (
                                                                            <span className={`badge ${moyenneAvisClient.moyenne_5 >= 4.5 ? 'badge-success' : 'badge-danger'}`}>
                                                                                {moyenneAvisClient.moyenne_5 >= 4.5 ?
                                                                                    <><i className="fa fa-check"></i> OK</> :
                                                                                    <><i className="fa fa-times"></i> Non-atteint</>
                                                                                }
                                                                            </span>
                                                                        ) : (
                                                                            <span className="badge badge-secondary">N/A</span>
                                                                        )}
                                                                    </td>
                                                                </tr>

                                                                {/* NPS */}
                                                                <tr>
                                                                    <td>NPS (Net Promoter Score)</td>
                                                                    <td>≥ 50</td>
                                                                    <td>
                                                                        {loadingMoyenneAvis ? (
                                                                            <span className="text-muted">Calcul en cours...</span>
                                                                        ) : moyenneAvisClient && moyenneAvisClient.nps_score !== undefined ? (
                                                                            <span>
                                                                                {moyenneAvisClient.nps_score || '0'}
                                                                                {/* {moyenneAvisClient.promoteurs !== undefined && moyenneAvisClient.detracteurs !== undefined && (
                    <small className="text-muted ml-2">
                        (P: {moyenneAvisClient.promoteurs || '0'}, D: {moyenneAvisClient.detracteurs || '0'})
                    </small>
                )} */}
                                                                            </span>
                                                                        ) : (
                                                                            <span className="text-muted">Données indisponibles</span>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {loadingMoyenneAvis ? (
                                                                            <span className="badge badge-warning">
                                                                                <i className="fa fa-spinner fa-spin mr-1"></i> Chargement
                                                                            </span>
                                                                        ) : moyenneAvisClient && moyenneAvisClient.nps_score !== undefined ? (
                                                                            <span className={`badge ${moyenneAvisClient.nps_score >= 50 ? 'badge-success' : 'badge-danger'}`}>
                                                                                {moyenneAvisClient.nps_score >= 50 ?
                                                                                    <><i className="fa fa-check"></i> OK</> :
                                                                                    <><i className="fa fa-times"></i> Non-atteint</>
                                                                                }
                                                                            </span>
                                                                        ) : (
                                                                            <span className="badge badge-secondary">N/A</span>
                                                                        )}
                                                                    </td>
                                                                </tr>

                                                                {/* Progression pré-test */}
                                                                <tr>
                                                                    <td>Progression pré-test</td>
                                                                    <td>≥ 30%</td>
                                                                    <td>
                                                                        {testProgress?.preTest?.existe ? (
                                                                            <div>
                                                                                <span>{Math.round(testProgress.preTest.moyenne || 0)}%</span>
                                                                            </div>
                                                                        ) : (
                                                                            <div>
                                                                                <span className="text-muted">Non applicable</span>
                                                                                <br />
                                                                                <small className="text-muted">Aucun pré-test dans le dernier parcours</small>
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {testProgress?.preTest?.existe ? (
                                                                            <span className={`badge ${testProgress.preTest.objectifAtteint ? 'badge-success' : 'badge-danger'}`}>
                                                                                {testProgress.preTest.objectifAtteint ? (
                                                                                    <><i className="fa fa-check"></i> OK</>
                                                                                ) : (
                                                                                    <><i className="fa fa-times"></i> Non-atteint</>
                                                                                )}
                                                                            </span>
                                                                        ) : (
                                                                            <span className="badge badge-secondary">N/A</span>
                                                                        )}
                                                                    </td>
                                                                </tr>

                                                                {/* Progression post-test */}
                                                                <tr>
                                                                    <td>Progression post-test</td>
                                                                    <td>≥ 30%</td>
                                                                    <td>
                                                                        {testProgress?.postTest?.existe ? (
                                                                            <div>
                                                                                <span>{Math.round(testProgress.postTest.moyenne || 0)}%</span>
                                                                            </div>
                                                                        ) : (
                                                                            <div>
                                                                                <span className="text-muted">Non applicable</span>
                                                                                <br />
                                                                                <small className="text-muted">Aucun post-test dans le dernier parcours</small>
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {testProgress?.postTest?.existe ? (
                                                                            <span className={`badge ${testProgress.postTest.objectifAtteint ? 'badge-success' : 'badge-danger'}`}>
                                                                                {testProgress.postTest.objectifAtteint ? (
                                                                                    <><i className="fa fa-check"></i> OK</>
                                                                                ) : (
                                                                                    <><i className="fa fa-times"></i> Non-atteint</>
                                                                                )}
                                                                            </span>
                                                                        ) : (
                                                                            <span className="badge badge-secondary">N/A</span>
                                                                        )}
                                                                    </td>
                                                                </tr>

                                                                {/* Progression pré/post test */}
                                                                <tr>
                                                                    <td>Progression pré/post test</td>
                                                                    <td>≥ 30%</td>
                                                                    <td>
                                                                        {testProgress?.progression?.calculable ? (
                                                                            <div>
                                                                                <span>{Math.round(testProgress.progression.valeur)}%</span>
                                                                            </div>
                                                                        ) : (
                                                                            <div>
                                                                                {testProgress?.preTest?.existe || testProgress?.postTest?.existe ? (
                                                                                    <>
                                                                                        <small className="text-muted">
                                                                                            {testProgress.preTest?.existe ? `Pré-test: ${Math.round(testProgress.preTest.moyenne || 0)}%` : ''}
                                                                                            {testProgress.preTest?.existe && testProgress.postTest?.existe ? ' | ' : ''}
                                                                                            {testProgress.postTest?.existe ? `Post-test: ${Math.round(testProgress.postTest.moyenne || 0)}%` : ''}
                                                                                        </small>
                                                                                    </>
                                                                                ) : (
                                                                                    "Aucun test d'évaluation dans le dernier parcours"
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {testProgress?.progression?.calculable ? (
                                                                            <span className={`badge ${testProgress.progression.objectifAtteint ? 'badge-success' : 'badge-danger'}`}>
                                                                                {testProgress.progression.objectifAtteint ? (
                                                                                    <><i className="fa fa-check"></i> OK</>
                                                                                ) : (
                                                                                    <><i className="fa fa-times"></i> Non-atteint</>
                                                                                )}
                                                                            </span>
                                                                        ) : (
                                                                            <span className="badge badge-secondary">N/A</span>
                                                                        )}
                                                                    </td>
                                                                </tr>

                                                                {/* Taux de certification PMP */}
                                                                <tr>
                                                                    <td>Taux de certification PMP</td>
                                                                    <td>≥ 90%</td>
                                                                    <td>
                                                                        {(() => {
                                                                            const certifiedUsers = groupeUsers.filter(user =>
                                                                                user.certification && user.certification === "Oui"
                                                                            ).length;
                                                                            const percentage = groupeUsers.length > 0 ?
                                                                                Math.round((certifiedUsers / groupeUsers.length) * 100) :
                                                                                0;
                                                                            return `${percentage}%`;
                                                                        })()}
                                                                    </td>
                                                                    <td>
                                                                        {(() => {
                                                                            const certifiedUsers = groupeUsers.filter(user =>
                                                                                user.certification && user.certification === "Oui"
                                                                            ).length;
                                                                            const percentage = groupeUsers.length > 0 ?
                                                                                (certifiedUsers / groupeUsers.length) * 100 :
                                                                                0;
                                                                            const isOK = percentage >= 90;
                                                                            return (
                                                                                <span className={`badge ${isOK ? 'badge-success' : 'badge-danger'}`}>
                                                                                    {isOK ?
                                                                                        <><i className="fa fa-check"></i> OK</> :
                                                                                        <><i className="fa fa-times"></i> Non-atteint</>
                                                                                    }
                                                                                </span>
                                                                            );
                                                                        })()}
                                                                    </td>
                                                                </tr>

                                                                {/* Délai moyen examens */}
                                                                {/* <tr>
                                                                    <td>Délai moyen entre fin de formation et passage à l'examen</td>
                                                                    <td>≤ 45 jours</td>
                                                                    <td>Données indisponibles</td>
                                                                    <td>
                                                                        <span className="badge badge-secondary">
                                                                            N/A
                                                                        </span>
                                                                    </td>
                                                                </tr> */}

                                                                {/* Taux d'abandon */}
                                                                <tr>
                                                                    <td>Taux d'abandon post-formation</td>
                                                                    <td>≤ 10%</td>
                                                                    <td>
                                                                        {(() => {
                                                                            if (!testProgress?.postTest?.existe || Object.keys(listeEtape).length === 0) {
                                                                                return "Données indisponibles";
                                                                            }

                                                                            const parcoursArray = Object.values(listeEtape);
                                                                            const parcoursTries = parcoursArray.sort((a, b) => b.parcour_id - a.parcour_id);
                                                                            const dernierParcoursData = parcoursTries[0];

                                                                            const postTestEtapes = dernierParcoursData.etapes.filter(etape =>
                                                                                etape.module && etape.module.toLowerCase().includes("evaluation") &&
                                                                                etape.type_evaluation && etape.type_evaluation.toLowerCase() === "post"
                                                                            );

                                                                            if (postTestEtapes.length === 0) {
                                                                                return "Post-test non trouvé";
                                                                            }

                                                                            const postTestEtape = postTestEtapes[postTestEtapes.length - 1];
                                                                            const postTestIndex = dernierParcoursData.etapes.findIndex(etape => etape.id === postTestEtape.id);

                                                                            if (postTestIndex === -1) {
                                                                                return "Index post-test non trouvé";
                                                                            }

                                                                            const etapesApresPostTest = dernierParcoursData.etapes.slice(postTestIndex + 1);

                                                                            if (etapesApresPostTest.length < 3) {
                                                                                return "Pas assez d'étapes après le post-test";
                                                                            }

                                                                            let totalUsers = 0;
                                                                            let abandonedUsers = 0;

                                                                            dernierParcoursData.utilisateurs.forEach(user => {
                                                                                user.fichiers.forEach(fichier => {
                                                                                    let etapesNonTerminees = 0;

                                                                                    etapesApresPostTest.forEach(etape => {
                                                                                        const etapeUtilisateur = fichier.etapes.find(e =>
                                                                                            e.id === etape.id || e.titre === etape.titre
                                                                                        );

                                                                                        if (!etapeUtilisateur || etapeUtilisateur.statut !== 'Terminée') {
                                                                                            etapesNonTerminees++;
                                                                                        }
                                                                                    });

                                                                                    if (etapesNonTerminees > 2) {
                                                                                        abandonedUsers++;
                                                                                    }
                                                                                    totalUsers++;
                                                                                });
                                                                            });

                                                                            const tauxAbandon = totalUsers > 0 ? Math.round((abandonedUsers / totalUsers) * 100) : 0;
                                                                            return `${tauxAbandon}%`;
                                                                        })()}
                                                                    </td>
                                                                    <td>
                                                                        {(() => {
                                                                            if (!testProgress?.postTest?.existe || Object.keys(listeEtape).length === 0) {
                                                                                return <span className="badge badge-secondary">N/A</span>;
                                                                            }

                                                                            const parcoursArray = Object.values(listeEtape);
                                                                            const parcoursTries = parcoursArray.sort((a, b) => b.parcour_id - a.parcour_id);
                                                                            const dernierParcoursData = parcoursTries[0];

                                                                            const postTestEtapes = dernierParcoursData.etapes.filter(etape =>
                                                                                etape.module && etape.module.toLowerCase().includes("evaluation") &&
                                                                                etape.type_evaluation && etape.type_evaluation.toLowerCase() === "post"
                                                                            );

                                                                            if (postTestEtapes.length === 0) {
                                                                                return <span className="badge badge-secondary">N/A</span>;
                                                                            }

                                                                            const postTestEtape = postTestEtapes[postTestEtapes.length - 1];
                                                                            const postTestIndex = dernierParcoursData.etapes.findIndex(etape => etape.id === postTestEtape.id);

                                                                            if (postTestIndex === -1 || postTestIndex >= dernierParcoursData.etapes.length - 3) {
                                                                                return <span className="badge badge-secondary">N/A</span>;
                                                                            }

                                                                            let totalUsers = 0;
                                                                            let abandonedUsers = 0;

                                                                            dernierParcoursData.utilisateurs.forEach(user => {
                                                                                user.fichiers.forEach(fichier => {
                                                                                    const etapesApresPostTest = dernierParcoursData.etapes.slice(postTestIndex + 1);
                                                                                    let etapesNonTerminees = 0;

                                                                                    etapesApresPostTest.forEach(etape => {
                                                                                        const etapeUtilisateur = fichier.etapes.find(e =>
                                                                                            e.id === etape.id || e.titre === etape.titre
                                                                                        );

                                                                                        if (!etapeUtilisateur || etapeUtilisateur.statut !== 'Terminée') {
                                                                                            etapesNonTerminees++;
                                                                                        }
                                                                                    });

                                                                                    if (etapesNonTerminees > 2) {
                                                                                        abandonedUsers++;
                                                                                    }
                                                                                    totalUsers++;
                                                                                });
                                                                            });

                                                                            const tauxAbandon = totalUsers > 0 ? (abandonedUsers / totalUsers) * 100 : 0;
                                                                            const isOK = tauxAbandon <= 10;

                                                                            return (
                                                                                <span className={`badge ${isOK ? 'badge-success' : 'badge-danger'}`}>
                                                                                    {isOK ? (
                                                                                        <><i className="fa fa-check"></i> OK</>
                                                                                    ) : (
                                                                                        <><i className="fa fa-times"></i> Non-atteint</>
                                                                                    )}
                                                                                </span>
                                                                            );
                                                                        })()}
                                                                    </td>
                                                                </tr>

                                                                {/* Sessions de coaching */}
                                                                <tr>
                                                                    <td>Nombre de sessions de coaching suivies par apprenant</td>
                                                                    <td>≥ 5 (20h)</td>
                                                                    <td>
                                                                        {sessionsCoaching.loading ? (
                                                                            <div>
                                                                                <span className="text-muted">Chargement...</span>
                                                                            </div>
                                                                        ) : sessionsCoaching.erreur ? (
                                                                            <div>
                                                                                <span className="text-danger">Données indisponibles</span>
                                                                                <br />
                                                                                <small className="text-muted">{sessionsCoaching.erreur}</small>
                                                                            </div>
                                                                        ) : (
                                                                            <div>
                                                                                <span>{Math.round(sessionsCoaching.moyenne)} sessions</span>
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {sessionsCoaching.loading ? (
                                                                            <span className="badge badge-warning">Chargement...</span>
                                                                        ) : sessionsCoaching.erreur ? (
                                                                            <span className="badge badge-secondary">N/A</span>
                                                                        ) : (
                                                                            <span className={`badge ${sessionsCoaching.moyenne >= 5 ? 'badge-success' : 'badge-danger'}`}>
                                                                                {sessionsCoaching.moyenne >= 5 ? (
                                                                                    <><i className="fa fa-check"></i> OK</>
                                                                                ) : (
                                                                                    <><i className="fa fa-times"></i> Non-atteint</>
                                                                                )}
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className="col-md-8 ibox-content" style={{ borderRadius: "15px" }}>
                                        <div className="d-flex justify-content-center align-items-center h-100">
                                            <div className="spiner-example">
                                                <div className="sk-spinner sk-spinner-wave">
                                                    <div className="sk-rect1 mr-1"></div>
                                                    <div className="sk-rect2 mr-1"></div>
                                                    <div className="sk-rect3 mr-1"></div>
                                                    <div className="sk-rect4 mr-1"></div>
                                                    <div className="sk-rect5"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfigurerGroupe;
